import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import api, { handleApi } from "pages/api/api";
import { useAlert } from "pages/context/AlertContext";
import { useAuth } from "pages/context/AuthContext";
import PageHeader from "pages/components/PageHeader";
import { useSpeechRecognition } from "pages/components/useSpeechRecognition";
import { startConnection, getConnection } from "pages/services/signalRService";

import Draggable from "react-draggable";
import Paper from "@mui/material/Paper";

import EmojiPicker from "emoji-picker-react";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

import Card from "@mui/material/Card";
import CircularProgress from "@mui/material/CircularProgress";
import Divider from "@mui/material/Divider";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Autocomplete from "@mui/material/Autocomplete";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Icon from "@mui/material/Icon";

import DoneAllIcon from "@mui/icons-material/DoneAll";
import DoneIcon from "@mui/icons-material/Done";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import DescriptionIcon from "@mui/icons-material/Description";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import SendIcon from "@mui/icons-material/Send";
import MicIcon from "@mui/icons-material/Mic";
import StopCircleIcon from "@mui/icons-material/StopCircle";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ReplyIcon from "@mui/icons-material/Reply";
import ForwardIcon from "@mui/icons-material/Forward";
import EmailIcon from "@mui/icons-material/Email";
import EmojiEmotionsIcon from "@mui/icons-material/EmojiEmotions";
import ThumbUpAltOutlinedIcon from "@mui/icons-material/ThumbUpAltOutlined";

function PaperComponent(props) {
  return (
    <Draggable
      handle="#dialog-resultados-pesquisa-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

export default function Chats() {
  const { showAlert } = useAlert();
  const { userData } = useAuth();
  const navigate = useNavigate();
  const { idchat, idmensagem } = useParams();

  const [loading, setLoading] = useState(false);
  const [chats, setChats] = useState([]);
  const [chatSelecionado, setChatSelecionado] = useState(null);
  const [mensagens, setMensagens] = useState([]);
  const [loadingMensagens, setLoadingMensagens] = useState(false);

  const [textoPesquisaChat, setTextoPesquisaChat] = useState("");
  const [resultadosPesquisaChat, setResultadosPesquisaChat] = useState([]);
  const [loadingPesquisaChat, setLoadingPesquisaChat] = useState(false);

  const [textoPesquisaGlobal, setTextoPesquisaGlobal] = useState("");
  const [resultadosPesquisaGlobal, setResultadosPesquisaGlobal] = useState([]);
  const [loadingPesquisaGlobal, setLoadingPesquisaGlobal] = useState(false);

  const [textoMensagem, setTextoMensagem] = useState("");
  const [enviandoMensagem, setEnviandoMensagem] = useState(false);

  const [mensagemEmResposta, setMensagemEmResposta] = useState(null);
  const [mensagemEmEdicao, setMensagemEmEdicao] = useState(null);
  const [mensagemAReencaminhar, setMensagemAReencaminhar] = useState(null);
  const [chatDestinoReencaminhar, setChatDestinoReencaminhar] = useState(null);
  const [openReencaminhar, setOpenReencaminhar] = useState(false);
  const [aReencaminhar, setAReencaminhar] = useState(false);

  const [mensagemAEnviarEmail, setMensagemAEnviarEmail] = useState(null);
  const [openEnviarEmail, setOpenEnviarEmail] = useState(false);
  const [utilizadoresEmail, setUtilizadoresEmail] = useState([]);
  const [emailsLivres, setEmailsLivres] = useState("");
  const [aEnviarEmail, setAEnviarEmail] = useState(false);

  const [membrosChat, setMembrosChat] = useState([]);
  const [menuMencoesOpen, setMenuMencoesOpen] = useState(false);
  const [mencoesFiltradas, setMencoesFiltradas] = useState([]);
  const [textoMencaoAtual, setTextoMencaoAtual] = useState("");
  const [mencoesSelecionadas, setMencoesSelecionadas] = useState([]);
  const [indiceMencaoAtiva, setIndiceMencaoAtiva] = useState(0);
  const [ficheirosAnexos, setFicheirosAnexos] = useState([]);
  const [previewTextoPorAnexo, setPreviewTextoPorAnexo] = useState({});
  const [canCamera, setCanCamera] = useState(false);
  const [openInfoVoz, setOpenInfoVoz] = useState(false);
  const [openEmojiPicker, setOpenEmojiPicker] = useState(false);
  const [mensagemReacaoOpen, setMensagemReacaoOpen] = useState(null);
  const [openDetalheReacoes, setOpenDetalheReacoes] = useState(false);
  const [mensagemReacoesDetalhe, setMensagemReacoesDetalhe] = useState(null);
  const [reacoesDetalhe, setReacoesDetalhe] = useState([]);
  const [loadingReacoesDetalhe, setLoadingReacoesDetalhe] = useState(false);
  const [filtroAnexosMeses, setFiltroAnexosMeses] = useState(1);
  const [openMobileChats, setOpenMobileChats] = useState(false);
  const [openMobileAnexos, setOpenMobileAnexos] = useState(false);

  const [openMembrosChat, setOpenMembrosChat] = useState(false);
  const [novoMembroChat, setNovoMembroChat] = useState(null);
  const [aAtualizarMembros, setAAtualizarMembros] = useState(false);
  const [openConfirmarRemoverMembro, setOpenConfirmarRemoverMembro] = useState(false);
  const [membroParaRemover, setMembroParaRemover] = useState(null);
  const [openNovoChat, setOpenNovoChat] = useState(false);

  const [utilizadores, setUtilizadores] = useState([]);
  const [loadingUtilizadores, setLoadingUtilizadores] = useState(false);
  const [aCriarChat, setACriarChat] = useState(false);
  const [mensagemHighlight, setMensagemHighlight] = useState(null);
  const [mensagemGlobalPendente, setMensagemGlobalPendente] = useState(null);

  const [signalRPronto, setSignalRPronto] = useState(false);
  const [utilizadoresAEscrever, setUtilizadoresAEscrever] = useState([]);

  const typingTimeoutRef = useRef(null);
  const primeiraNaoLidaRef = useRef(null);
  const ignorarScrollDepoisRefreshRef = useRef(false);
  const scrollTopAntesReacaoRef = useRef(null);
  const marcarLidoEmCursoRef = useRef(false);

  const [novoChat, setNovoChat] = useState({
    designacao: "",
    descricao: "",
    membros: [],
  });

  const blocoChatsRef = useRef(null);
  const blocoAnexosRef = useRef(null);
  const mensagensRef = useRef(null);
  const inputAnexosRef = useRef(null);
  const inputCameraRef = useRef(null);

  const adicionarTextoDitado = useCallback((texto) => {
    if (!texto) return;

    setTextoMensagem((prev) => {
      const atual = String(prev || "").trimEnd();
      return atual ? `${atual}\n${texto}` : texto;
    });
  }, []);

  const {
    iniciar: iniciarVoz,
    parar: pararVoz,
    reconhecendo: reconhecendoVoz,
    suporteVoz,
    erro: erroVoz,
  } = useSpeechRecognition(adicionarTextoDitado, {
    lang: "pt-PT",
    interimResults: false,
    continuous: true,
  });

  const carregarChats = async () => {
    if (!userData?.id) return;

    setLoading(true);

    const [data, err] = await handleApi(
      api.post("Chats/SelChatsVisiveis", {
        idutilizador: userData.id,
      })
    );

    if (err) {
      showAlert(err, "error");
      setChats([]);
      setLoading(false);
      return;
    }

    const lista = Array.isArray(data) ? data : [];
    setChats(lista);

    if (lista.length > 0) {
      setChatSelecionado((prev) => {
        if (idchat) {
          const chatUrl = lista.find((x) => String(x.id) === String(idchat));
          if (chatUrl) return chatUrl;
        }

        if (prev && lista.some((x) => String(x.id) === String(prev.id))) return prev;

        return lista[0];
      });
    } else {
      setChatSelecionado(null);
    }

    setLoading(false);
  };

  const carregarMembrosChat = async (idchat) => {
    if (!userData?.id || !idchat) return;

    const [data, err] = await handleApi(
      api.post("Chats/SelChatsVisiveis", {
        idutilizador: userData.id,
      })
    );

    if (err) {
      setMembrosChat([]);
      return;
    }

    const listaChats = Array.isArray(data) ? data : [];
    const chatAtual = listaChats.find((x) => String(x.id) === String(idchat));

    if (!chatAtual) {
      setMembrosChat([]);
      return;
    }

    const [membrosData, membrosErr] = await handleApi(
      api.post("Chats/SelMembrosChat", {
        idchat,
        idutilizador: userData.id,
      })
    );

    if (membrosErr) {
      setMembrosChat([]);
      return;
    }

    setMembrosChat(Array.isArray(membrosData) ? membrosData : []);
  };

  const pesquisarMensagensGlobal = async () => {
    if (!userData?.id) return;

    const termos = String(textoPesquisaGlobal || "").trim();

    if (!termos) {
      setResultadosPesquisaGlobal([]);
      return;
    }

    setLoadingPesquisaGlobal(true);

    const [data, err] = await handleApi(
      api.post("Chats/PesquisarMensagensChats", {
        idutilizador: userData.id,
        termos,
      })
    );

    if (err) {
      showAlert(err, "error");
      setResultadosPesquisaGlobal([]);
      setLoadingPesquisaGlobal(false);
      return;
    }

    setResultadosPesquisaGlobal(Array.isArray(data) ? data : []);
    setLoadingPesquisaGlobal(false);
  };

  const pesquisarMensagensChat = async () => {
    if (!userData?.id || !chatSelecionado?.id) return;

    const termos = String(textoPesquisaChat || "").trim();

    if (!termos) {
      setResultadosPesquisaChat([]);
      return;
    }

    setLoadingPesquisaChat(true);

    const [data, err] = await handleApi(
      api.post("Chats/PesquisarMensagensChat", {
        idchat: chatSelecionado.id,
        idutilizador: userData.id,
        termos,
      })
    );

    if (err) {
      showAlert(err, "error");
      setResultadosPesquisaChat([]);
      setLoadingPesquisaChat(false);
      return;
    }

    setResultadosPesquisaChat(Array.isArray(data) ? data : []);
    setLoadingPesquisaChat(false);
  };

  const carregarMensagens = async (idchat) => {
    if (!userData?.id || !idchat) return;

    setLoadingMensagens(true);

    const [data, err] = await handleApi(
      api.post("Chats/SelMensagensChat", {
        idchat,
        idutilizador: userData.id,
      })
    );

    if (err) {
      showAlert(err, "error");
      setMensagens([]);
      setLoadingMensagens(false);
      return;
    }

    const listaMensagens = Array.isArray(data) ? data : [];

    const primeiraNaoLida = listaMensagens.find((m) => {
      const minha = String(m.idutilizador) === String(userData?.id);
      const lida =
        m.lida_pelo_utilizador === true ||
        Number(m.lida_pelo_utilizador) === 1 ||
        String(m.lida_pelo_utilizador).toLowerCase() === "true";

      return !minha && !lida;
    });

    if (idmensagem) {
      primeiraNaoLidaRef.current = null;
    } else if (!ignorarScrollDepoisRefreshRef.current) {
      primeiraNaoLidaRef.current = primeiraNaoLida?.id || null;
    }

    // console.log(
    //   "Mensagens carregadas:",
    //   listaMensagens.map((m) => ({
    //     id: m.id,
    //     datahora_envio: m.datahora_envio,
    //     texto: m.texto,
    //   }))
    // );

    setMensagens(listaMensagens);
    setLoadingMensagens(false);
  };

  const carregarUtilizadores = async () => {
    if (!userData?.id) return;

    setLoadingUtilizadores(true);

    const [data, err] = await handleApi(api.post("UtilizadoresAcessos/SelUtilizadores", {}));

    if (err) {
      showAlert(err, "error");
      setUtilizadores([]);
      setLoadingUtilizadores(false);
      return;
    }

    const lista = Array.isArray(data) ? data : [];

    setUtilizadores(
      lista.filter((u) => String(u.id) !== String(userData.id) && Number(u.inativo || 0) === 0)
    );

    setLoadingUtilizadores(false);
  };

  const handleOpenNovoChat = async () => {
    setNovoChat({
      designacao: "",
      descricao: "",
      membros: [],
    });

    setOpenNovoChat(true);
    await carregarUtilizadores();
  };

  const handleOpenMembrosChat = async () => {
    setNovoMembroChat(null);
    setOpenMembrosChat(true);

    await carregarUtilizadores();

    if (chatSelecionado?.id) {
      await carregarMembrosChat(chatSelecionado.id);
    }
  };

  const adicionarMembroChat = async (utilizador) => {
    if (!chatSelecionado?.id || !userData?.id || !utilizador?.id) return;

    setAAtualizarMembros(true);

    const [data, err, meta] = await handleApi(
      api.post("Chats/InsMembroChat", {
        idchat: chatSelecionado.id,
        idutilizadoracao: userData.id,
        idutilizador: utilizador.id,
      })
    );

    if (err) {
      showAlert(err, "error");
      setAAtualizarMembros(false);
      return;
    }

    if (meta?.message) {
      showAlert(meta.message, meta.severity || "success");
    }

    setNovoMembroChat(null);

    await carregarMembrosChat(chatSelecionado.id);

    const [listaChats] = await handleApi(
      api.post("Chats/SelChatsVisiveis", {
        idutilizador: userData.id,
      })
    );

    const lista = Array.isArray(listaChats) ? listaChats : [];
    setChats(lista);

    const chatAtualizado = lista.find((x) => String(x.id) === String(chatSelecionado.id));
    if (chatAtualizado) {
      setChatSelecionado(chatAtualizado);
    }

    setAAtualizarMembros(false);
  };

  const removerMembroChat = async (membro) => {
    const idutilizadorRemover = membro?.idutilizador || membro?.id;

    if (!chatSelecionado?.id || !userData?.id || !idutilizadorRemover) return;

    setAAtualizarMembros(true);

    const [data, err, meta] = await handleApi(
      api.post("Chats/DelMembroChat", {
        idchat: chatSelecionado.id,
        idutilizadoracao: userData.id,
        idutilizador: idutilizadorRemover,
      })
    );

    if (err) {
      showAlert(err, "error");
      setAAtualizarMembros(false);
      return;
    }

    if (meta?.message) {
      showAlert(meta.message, meta.severity || "success");
    }

    await carregarMembrosChat(chatSelecionado.id);

    const [listaChats] = await handleApi(
      api.post("Chats/SelChatsVisiveis", {
        idutilizador: userData.id,
      })
    );

    const lista = Array.isArray(listaChats) ? listaChats : [];
    setChats(lista);

    const chatAtualizado = lista.find((x) => String(x.id) === String(chatSelecionado.id));
    if (chatAtualizado) {
      setChatSelecionado(chatAtualizado);
    }

    setAAtualizarMembros(false);
  };

  const criarNovoChat = async () => {
    if (!userData?.id) return;

    if (!novoChat.membros.length) {
      showAlert("Selecione pelo menos um utilizador.", "warning");
      return;
    }

    setACriarChat(true);

    const [data, err, meta] = await handleApi(
      api.post("Chats/InsChat", {
        designacao: novoChat.designacao,
        descricao: novoChat.descricao,
        idutilizadorcriador: userData.id,
        idutilizadores: novoChat.membros.map((x) => x.id),
      })
    );

    if (err) {
      showAlert(err, "error");
      setACriarChat(false);
      return;
    }

    if (meta?.message) {
      showAlert(meta.message, meta.severity || "success");
    }

    setOpenNovoChat(false);
    await carregarChats();

    if (data?.id) {
      const [listaChats] = await handleApi(
        api.post("Chats/SelChatsVisiveis", {
          idutilizador: userData.id,
        })
      );

      const lista = Array.isArray(listaChats) ? listaChats : [];
      const chatCriado = lista.find((x) => String(x.id) === String(data.id));

      setChats(lista);

      if (chatCriado) {
        setChatSelecionado(chatCriado);
        await carregarMensagens(chatCriado.id);
      }
    }

    setACriarChat(false);
  };

  const guardarEdicaoMensagem = async () => {
    if (!userData?.id || !mensagemEmEdicao?.id) return;
    if (!textoMensagem.trim()) return;

    setEnviandoMensagem(true);

    const [data, err, meta] = await handleApi(
      api.post("Chats/UpdMensagemChat", {
        idmensagem: mensagemEmEdicao.id,
        idutilizador: userData.id,
        texto: textoMensagem.trim(),
      })
    );

    if (err) {
      showAlert(err, "error");
      setEnviandoMensagem(false);
      return;
    }

    if (meta?.message) {
      showAlert(meta.message, meta.severity || "success");
    }

    setTextoMensagem("");
    setMensagemEmEdicao(null);
    await carregarMensagens(chatSelecionado.id);
    await carregarChats();

    setEnviandoMensagem(false);
  };

  const abrirReencaminharMensagem = (mensagem) => {
    if (!mensagem?.id) return;

    setMensagemAReencaminhar(mensagem);
    setChatDestinoReencaminhar(null);
    setOpenReencaminhar(true);
  };

  const confirmarReencaminharMensagem = async () => {
    if (!userData?.id || !mensagemAReencaminhar?.id || !chatDestinoReencaminhar?.id) return;

    setAReencaminhar(true);

    const [data, err, meta] = await handleApi(
      api.post("Chats/ReencaminharMensagemChat", {
        idmensagem_origem: mensagemAReencaminhar.id,
        idchat_destino: chatDestinoReencaminhar.id,
        idutilizador: userData.id,
      })
    );

    if (err) {
      showAlert(err, "error");
      setAReencaminhar(false);
      return;
    }

    if (meta?.message) {
      showAlert(meta.message, meta.severity || "success");
    }

    setOpenReencaminhar(false);
    setMensagemAReencaminhar(null);
    setChatDestinoReencaminhar(null);

    await carregarChats();

    if (data?.idchat) {
      const chatAlvo = chats.find((c) => String(c.id) === String(data.idchat));
      if (chatAlvo) {
        setMensagemGlobalPendente(data.id);
        setChatSelecionado(chatAlvo);
      }
    }

    setAReencaminhar(false);
  };

  const apagarMensagem = async (mensagem) => {
    if (!userData?.id || !mensagem?.id || !chatSelecionado?.id) return;

    setEnviandoMensagem(true);

    const [data, err, meta] = await handleApi(
      api.post("Chats/DelMensagemChat", {
        idmensagem: mensagem.id,
        idutilizador: userData.id,
      })
    );

    if (err) {
      showAlert(err, "error");
      setEnviandoMensagem(false);
      return;
    }

    if (meta?.message) {
      showAlert(meta.message, meta.severity || "success");
    }

    if (mensagemEmEdicao?.id === mensagem.id) {
      setMensagemEmEdicao(null);
      setTextoMensagem("");
    }

    if (mensagemEmResposta?.id === mensagem.id) {
      setMensagemEmResposta(null);
    }

    await carregarMensagens(chatSelecionado.id);
    await carregarChats();

    setEnviandoMensagem(false);
  };

  const abrirDetalheReacoes = async (mensagem) => {
    if (!userData?.id || !mensagem?.id) return;

    setMensagemReacoesDetalhe(mensagem);
    setOpenDetalheReacoes(true);
    setLoadingReacoesDetalhe(true);
    setReacoesDetalhe([]);

    const [data, err] = await handleApi(
      api.post("Chats/SelReacoesMensagem", {
        idmensagem: mensagem.id,
        idutilizador: userData.id,
      })
    );

    if (err) {
      showAlert(err, "error");
      setLoadingReacoesDetalhe(false);
      return;
    }

    setReacoesDetalhe(Array.isArray(data) ? data : []);
    setLoadingReacoesDetalhe(false);
  };

  const reagirMensagem = async (mensagem, emoji) => {
    if (!userData?.id || !mensagem?.id || !chatSelecionado?.id) return;

    const [, err] = await handleApi(
      api.post("Chats/InsOuUpdReacaoMensagem", {
        idmensagem: mensagem.id,
        idutilizador: userData.id,
        reacao: emoji,
      })
    );

    if (err) {
      showAlert(err, "error");
    }
  };

  const enviarMensagem = async () => {
    if (!userData?.id || !chatSelecionado?.id) return;
    if (!textoMensagem.trim() && ficheirosAnexos.length === 0) return;

    setEnviandoMensagem(true);

    const [data, err, meta] = await handleApi(
      api.post("Chats/InsMensagemChat", {
        idchat: chatSelecionado.id,
        idutilizador: userData.id,
        idmensagem_pai: mensagemEmResposta?.id || null,
        texto: textoMensagem.trim() || null,
        idutilizadoresmencionados: mencoesSelecionadas.map((x) => x.id),
      })
    );

    if (err) {
      showAlert(err, "error");
      setEnviandoMensagem(false);
      return;
    }

    if (data?.id && ficheirosAnexos.length > 0) {
      for (const ficheiro of ficheirosAnexos) {
        const ficheiroFinal = await comprimirImagemSeNecessario(ficheiro);

        const formData = new FormData();
        formData.append("idmensagem", String(data.id));
        formData.append("idutilizador", String(userData.id));
        formData.append("ficheiro", ficheiroFinal);

        const [, errUpload] = await handleApi(
          api.post("Chats/UploadAnexoMensagem", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
        );

        if (errUpload) {
          showAlert(errUpload, "error");
          setEnviandoMensagem(false);
          return;
        }
      }
    }

    if (meta?.message) {
      showAlert(meta.message, meta.severity || "success");
    }

    setTextoMensagem("");
    setOpenEmojiPicker(false);

    setMensagemEmResposta(null);
    setMencoesSelecionadas([]);
    setFicheirosAnexos([]);
    if (inputAnexosRef.current) {
      inputAnexosRef.current.value = "";
    }
    if (inputCameraRef.current) {
      inputCameraRef.current.value = "";
    }

    await carregarMensagens(chatSelecionado.id);
    await carregarChats();

    requestAnimationFrame(() => {
      scrollParaFimMensagens("auto");
      requestAnimationFrame(() => {
        scrollParaFimMensagens("smooth");
      });
    });

    setEnviandoMensagem(false);
  };

  const marcarChatComoLido = async (idchat) => {
    if (!userData?.id || !idchat) return;

    const [, err] = await handleApi(
      api.post("Chats/MarcarChatComoLido", {
        idchat,
        idutilizador: userData.id,
      })
    );

    if (err) {
      showAlert(err, "error");
      return;
    }

    await carregarChats();
  };

  const atualizarSugestoesMencao = (novoTexto) => {
    const match = novoTexto.match(/(?:^|\s)@([^\s@]*)$/);

    setMencoesSelecionadas((prev) =>
      prev.filter((m) => novoTexto.includes(`@${m.username || m.designacao}`))
    );

    if (!match) {
      setMenuMencoesOpen(false);
      setTextoMencaoAtual("");
      setMencoesFiltradas([]);
      setIndiceMencaoAtiva(0);
      return;
    }

    const termo = (match[1] || "").trim().toLowerCase();
    setTextoMencaoAtual(termo);

    const lista = membrosChat.filter((m) => {
      const nome = String(m.designacao || "").toLowerCase();
      const username = String(m.username || "").toLowerCase();
      return !termo || nome.includes(termo) || username.includes(termo);
    });

    const listaFinal = lista.slice(0, 8);

    setMencoesFiltradas(listaFinal);
    setMenuMencoesOpen(listaFinal.length > 0);
    setIndiceMencaoAtiva(0);
  };

  const handleTyping = async (texto) => {
    if (!signalRPronto || !chatSelecionado?.id || !userData?.id) return;

    const conn = getConnection();
    if (!conn || conn.state !== "Connected") return;

    try {
      // Enviar evento "está a escrever"
      await conn.invoke(
        "Escrever",
        Number(chatSelecionado.id),
        Number(userData.id),
        userData.designacao || userData.username
      );

      // Reset do timeout
      if (typingTimeoutRef.current) {
        clearTimeout(typingTimeoutRef.current);
      }

      // Após 2 segundos sem escrever → parar
      typingTimeoutRef.current = setTimeout(async () => {
        try {
          await conn.invoke("PararEscrever", Number(chatSelecionado.id), Number(userData.id));
        } catch {}
      }, 2000);
    } catch {}
  };

  const iniciarEdicaoMensagem = (mensagem) => {
    setMensagemEmResposta(null);
    setMenuMencoesOpen(false);
    setTextoMencaoAtual("");
    setMencoesFiltradas([]);
    setIndiceMencaoAtiva(0);
    setTextoMensagem(String(mensagem?.texto || ""));
    setMensagemEmEdicao(mensagem);
  };

  const cancelarEdicaoMensagem = () => {
    setMensagemEmEdicao(null);
    setTextoMensagem("");
    setFicheirosAnexos([]);
    if (inputAnexosRef.current) {
      inputAnexosRef.current.value = "";
    }
    if (inputCameraRef.current) {
      inputCameraRef.current.value = "";
    }
    setMenuMencoesOpen(false);
    setTextoMencaoAtual("");
    setMencoesFiltradas([]);
    setIndiceMencaoAtiva(0);
  };

  const selecionarMencao = (membro) => {
    const novoTexto = textoMensagem.replace(
      /(^|\s)@([^\s@]*)$/,
      `$1@${membro.username || membro.designacao} `
    );

    setTextoMensagem(novoTexto);
    setMencoesSelecionadas((prev) => {
      const jaExiste = prev.some((x) => String(x.id) === String(membro.id));
      if (jaExiste) return prev;
      return [...prev, membro];
    });
    setMenuMencoesOpen(false);
    setTextoMencaoAtual("");
    setMencoesFiltradas([]);
    setIndiceMencaoAtiva(0);
  };

  const handleSelecionarAnexos = (e) => {
    const novosFicheiros = Array.from(e.target.files || []);

    if (!novosFicheiros.length) return;

    const ficheirosValidos = [];

    novosFicheiros.forEach((ficheiro) => {
      const validacao = validarFicheiroAnexo(ficheiro);

      if (!validacao.ok) {
        showAlert(validacao.mensagem, validacao.tipo);
        return;
      }

      if (validacao.mensagem) {
        showAlert(validacao.mensagem, validacao.tipo);
      }

      ficheirosValidos.push(ficheiro);
    });

    if (!ficheirosValidos.length) return;

    setFicheirosAnexos((prev) => [...prev, ...ficheirosValidos]);
  };

  const removerAnexoSelecionado = (index) => {
    setFicheirosAnexos((prev) => prev.filter((_, i) => i !== index));

    if (inputAnexosRef.current && ficheirosAnexos.length <= 1) {
      inputAnexosRef.current.value = "";
    }
  };

  const handlePasteMensagem = (e) => {
    if (!chatSelecionado || enviandoMensagem || mensagemEmEdicao) return;

    const items = Array.from(e.clipboardData?.items || []);
    const ficheirosColados = [];

    items.forEach((item) => {
      if (!String(item.type || "").startsWith("image/")) return;

      const ficheiro = item.getAsFile();
      if (!ficheiro) return;

      const extensao = String(ficheiro.type || "").split("/")[1] || "png";
      const ficheiroFinal = new File(
        [ficheiro],
        `clipboard_${new Date().toISOString().replace(/[:.]/g, "-")}.${extensao}`,
        {
          type: ficheiro.type || "image/png",
          lastModified: Date.now(),
        }
      );

      const validacao = validarFicheiroAnexo(ficheiroFinal);

      if (!validacao.ok) {
        showAlert(validacao.mensagem, validacao.tipo);
        return;
      }

      if (validacao.mensagem) {
        showAlert(validacao.mensagem, validacao.tipo);
      }

      ficheirosColados.push(ficheiroFinal);
    });

    if (!ficheirosColados.length) return;

    e.preventDefault();

    setFicheirosAnexos((prev) => [...prev, ...ficheirosColados]);
    showAlert("Imagem colada e adicionada aos anexos da mensagem.", "success");
  };

  const handleKeyDownMensagem = async (e) => {
    if (menuMencoesOpen && mencoesFiltradas.length > 0) {
      if (e.key === "ArrowDown") {
        e.preventDefault();
        setIndiceMencaoAtiva((prev) => (prev + 1 >= mencoesFiltradas.length ? 0 : prev + 1));
        return;
      }

      if (e.key === "ArrowUp") {
        e.preventDefault();
        setIndiceMencaoAtiva((prev) => (prev - 1 < 0 ? mencoesFiltradas.length - 1 : prev - 1));
        return;
      }

      if (e.key === "Enter" && !e.shiftKey) {
        e.preventDefault();
        if (!enviandoMensagem) {
          if (mensagemEmEdicao) {
            await guardarEdicaoMensagem();
          } else {
            await enviarMensagem();
          }
        }
      }

      if (e.key === "Escape") {
        e.preventDefault();
        setMenuMencoesOpen(false);
        setIndiceMencaoAtiva(0);
        return;
      }
    }

    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      if (!enviandoMensagem) {
        if (mensagemEmEdicao) {
          await guardarEdicaoMensagem();
        } else {
          await enviarMensagem();
        }
      }
    }
  };

  const irParaMensagem = (idMensagemAlvo) => {
    if (!idMensagemAlvo) return;

    setMensagemHighlight(Number(idMensagemAlvo));

    requestAnimationFrame(() => {
      const el = document.getElementById(`mensagem-${idMensagemAlvo}`);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    });

    setTimeout(() => {
      setMensagemHighlight(null);
    }, 2200);
  };

  const scrollParaFimMensagens = (behavior = "smooth") => {
    const el = mensagensRef.current;
    if (!el) return;

    if (behavior === "auto") {
      el.scrollTop = el.scrollHeight;
      return;
    }

    el.scrollTo({
      top: el.scrollHeight,
      behavior,
    });
  };

  const scrollToRef = (ref) => {
    if (!ref?.current) return;

    const yOffset = -110; // ajusta se necessário (navbar)
    const y = ref.current.getBoundingClientRect().top + window.pageYOffset + yOffset;

    window.scrollTo({ top: y, behavior: "smooth" });
  };

  const scrollParaPrimeiraNaoLidaOuFim = (behavior = "auto") => {
    const primeiraNaoLida = mensagens.find((m) => {
      const minha = String(m.idutilizador) === String(userData?.id);
      const lida =
        m.lida_pelo_utilizador === true ||
        Number(m.lida_pelo_utilizador) === 1 ||
        String(m.lida_pelo_utilizador).toLowerCase() === "true";

      return !minha && !lida;
    });

    if (primeiraNaoLidaRef.current) {
      irParaMensagem(primeiraNaoLidaRef.current);
      primeiraNaoLidaRef.current = null;
      return;
    }

    if (primeiraNaoLida?.id) {
      irParaMensagem(primeiraNaoLida.id);
      return;
    }

    scrollParaUltimaMensagem(behavior);
  };

  const scrollParaUltimaMensagem = (behavior = "auto") => {
    if (!mensagens || mensagens.length === 0) return;

    const container = mensagensRef.current;
    if (!container) return;

    if (behavior === "auto") {
      container.scrollTop = container.scrollHeight;
      return;
    }

    container.scrollTo({
      top: container.scrollHeight,
      behavior,
    });
  };

  const handleScrollMensagens = async () => {
    if (!chatSelecionado?.id || !userData?.id) return;
    if (marcarLidoEmCursoRef.current) return;

    const el = mensagensRef.current;
    if (!el) return;

    const chegouAoFim = el.scrollHeight - el.scrollTop - el.clientHeight <= 24;
    if (!chegouAoFim) return;

    const temNaoLidas = mensagens.some((m) => {
      const minha = String(m.idutilizador) === String(userData?.id);
      const lida =
        m.lida_pelo_utilizador === true ||
        Number(m.lida_pelo_utilizador) === 1 ||
        String(m.lida_pelo_utilizador).toLowerCase() === "true";

      return !minha && !lida;
    });

    if (!temNaoLidas) return;

    marcarLidoEmCursoRef.current = true;

    await marcarChatComoLido(chatSelecionado.id);

    setMensagens((prev) =>
      Array.isArray(prev)
        ? prev.map((m) => ({
            ...m,
            lida_pelo_utilizador:
              String(m.idutilizador) === String(userData?.id) ? m.lida_pelo_utilizador : true,
          }))
        : prev
    );

    marcarLidoEmCursoRef.current = false;
  };

  const renderEstadoLeituraMensagem = (m, isMe) => {
    if (!isMe) return null;

    const totalDestinatarios = Number(m.total_destinatarios || 0);
    const totalLidas = Number(m.total_lidas || 0);

    if (totalDestinatarios > 0 && totalLidas >= totalDestinatarios) {
      return <DoneAllIcon sx={{ fontSize: 16, color: "#4fc3f7", ml: 0.4 }} />;
    }

    if (totalLidas > 0) {
      return <DoneAllIcon sx={{ fontSize: 16, color: "rgba(0,0,0,0.45)", ml: 0.4 }} />;
    }

    return <DoneIcon sx={{ fontSize: 16, color: "rgba(0,0,0,0.45)", ml: 0.4 }} />;
  };

  const renderTextoComMencoes = (texto) => {
    const conteudo = String(texto || "");
    const partes = conteudo.split(/(@[a-zA-Z0-9._-]+)/g);

    return partes.map((parte, index) => {
      if (/^@[a-zA-Z0-9._-]+$/.test(parte)) {
        return (
          <MDTypography
            key={index}
            component="span"
            variant="caption"
            sx={{
              color: "#1976d2",
              fontWeight: 700,
              textDecoration: "underline",
            }}
          >
            {parte}
          </MDTypography>
        );
      }

      return (
        <MDTypography
          key={index}
          component="span"
          variant="caption"
          sx={{ color: "inherit", fontWeight: "inherit" }}
        >
          {parte}
        </MDTypography>
      );
    });
  };

  const formatarTamanhoBytes = (valor) => {
    const bytes = Number(valor || 0);

    if (!Number.isFinite(bytes) || bytes <= 0) return "0 B";
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;

    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  };

  const getIniciaisUtilizador = (nome) => {
    if (!nome) return "?";

    const ignorar = ["da", "de", "do", "dos", "das", "e"];

    const parts = String(nome)
      .toLowerCase()
      .trim()
      .split(" ")
      .filter((p) => p && !ignorar.includes(p));

    if (parts.length === 0) return "?";

    if (parts.length === 1) return parts[0].substring(0, 2).toUpperCase();

    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  };

  const getUtilizadorImagemUrl = (id) => {
    if (!id) return "";
    return `/Uploads/Utilizadores/${id}/Imagens/${id}.jpg`;
  };

  const renderAvatarUtilizador = (utilizador, tamanho = 34) => {
    const id = utilizador?.idutilizador || utilizador?.id;
    const nome = utilizador?.designacao || utilizador?.nome || "";
    const iniciais = getIniciaisUtilizador(nome);

    return (
      <MDBox
        sx={{
          width: tamanho,
          height: tamanho,
          borderRadius: "50%",
          overflow: "hidden",
          flexShrink: 0,
          backgroundColor: "#f57c00",
          color: "#fff",
          fontSize: tamanho <= 34 ? 12 : 14,
          fontWeight: 700,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <img
          src={getUtilizadorImagemUrl(id)}
          alt={nome || "Utilizador"}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            display: "block",
          }}
          onError={(e) => {
            e.currentTarget.style.display = "none";
            e.currentTarget.parentElement.textContent = iniciais;
          }}
        />
      </MDBox>
    );
  };

  const validarFicheiroAnexo = (ficheiro) => {
    const tamanho = Number(ficheiro?.size || 0);
    const limiteAviso = 20 * 1024 * 1024;
    const limiteMaximo = 50 * 1024 * 1024;

    if (!isTipoAnexoPermitido(ficheiro)) {
      return {
        ok: false,
        tipo: "error",
        mensagem: `O ficheiro "${ficheiro.name}" não é de um tipo permitido.`,
      };
    }

    if (tamanho > limiteMaximo) {
      return {
        ok: false,
        tipo: "error",
        mensagem: `O ficheiro "${ficheiro.name}" excede o limite máximo de 50 MB.`,
      };
    }

    if (tamanho > limiteAviso) {
      return {
        ok: true,
        tipo: "warning",
        mensagem: `O ficheiro "${ficheiro.name}" tem mais de 20 MB e pode demorar a enviar.`,
      };
    }

    return { ok: true };
  };

  const isImagemFicheiro = (ficheiro) => {
    const nome = String(ficheiro?.name || "").toLowerCase();
    const type = String(ficheiro?.type || "").toLowerCase();

    return (
      type.startsWith("image/") ||
      nome.endsWith(".jpg") ||
      nome.endsWith(".jpeg") ||
      nome.endsWith(".png") ||
      nome.endsWith(".webp") ||
      nome.endsWith(".gif") ||
      nome.endsWith(".bmp")
    );
  };

  const extensaoFicheiro = (nome = "") => {
    const idx = String(nome).lastIndexOf(".");
    if (idx < 0) return "";
    return String(nome)
      .slice(idx + 1)
      .toLowerCase();
  };

  const isTipoAnexoPermitido = (ficheiro) => {
    const ext = extensaoFicheiro(ficheiro?.name || "");
    const type = String(ficheiro?.type || "").toLowerCase();

    const extsPermitidas = [
      "pdf",
      "jpg",
      "jpeg",
      "png",
      "webp",
      "gif",
      "bmp",
      "doc",
      "docx",
      "xls",
      "xlsx",
      "ppt",
      "pptx",
      "txt",
      "log",
      "csv",
      "zip",
    ];

    if (extsPermitidas.includes(ext)) return true;

    return (
      type === "application/pdf" ||
      type.startsWith("image/") ||
      type === "text/plain" ||
      type === "application/zip"
    );
  };

  const comprimirImagemSeNecessario = async (file) => {
    try {
      if (!file || !isImagemFicheiro(file)) return file;
      if (file.size <= 350 * 1024) return file;

      const MAX_DIM = 1600;
      const QUALITY = 0.75;

      const bitmap = await createImageBitmap(file);

      const w = bitmap.width;
      const h = bitmap.height;

      let nw = w;
      let nh = h;

      if (w >= h && w > MAX_DIM) {
        nw = MAX_DIM;
        nh = Math.round((h * MAX_DIM) / w);
      } else if (h > w && h > MAX_DIM) {
        nh = MAX_DIM;
        nw = Math.round((w * MAX_DIM) / h);
      }

      const canvas = document.createElement("canvas");
      canvas.width = nw;
      canvas.height = nh;

      const ctx = canvas.getContext("2d", { alpha: false });
      ctx.drawImage(bitmap, 0, 0, nw, nh);

      const blob = await new Promise((resolve) => canvas.toBlob(resolve, "image/jpeg", QUALITY));
      if (!blob) return file;

      const base = file.name?.replace(/\.[^/.]+$/, "") || "imagem";
      const compressed = new File([blob], `${base}.jpg`, {
        type: "image/jpeg",
        lastModified: Date.now(),
      });

      return compressed.size < file.size ? compressed : file;
    } catch {
      return file;
    }
  };

  const anexosSelecionadosPreview = useMemo(() => {
    return ficheirosAnexos.map((ficheiro) => ({
      ficheiro,
      urlPreview: isImagemFicheiro(ficheiro) ? URL.createObjectURL(ficheiro) : null,
    }));
  }, [ficheirosAnexos]);

  useEffect(() => {
    return () => {
      anexosSelecionadosPreview.forEach((item) => {
        if (item.urlPreview) URL.revokeObjectURL(item.urlPreview);
      });
    };
  }, [anexosSelecionadosPreview]);

  const isImagemAnexo = (anexo) => {
    const nome = String(anexo?.nome_original || anexo?.nome_fisico || "").toLowerCase();
    const contentType = String(anexo?.content_type || "").toLowerCase();

    return (
      contentType.startsWith("image/") ||
      nome.endsWith(".jpg") ||
      nome.endsWith(".jpeg") ||
      nome.endsWith(".png") ||
      nome.endsWith(".webp") ||
      nome.endsWith(".gif") ||
      nome.endsWith(".bmp")
    );
  };

  const isTextoSimplesAnexo = (anexo) => {
    const nome = String(anexo?.nome_original || anexo?.nome_fisico || "").toLowerCase();
    const contentType = String(anexo?.content_type || "").toLowerCase();

    return (
      contentType.startsWith("text/plain") ||
      nome.endsWith(".txt") ||
      nome.endsWith(".log") ||
      nome.endsWith(".csv")
    );
  };

  const renderAnexosMensagem = (mensagem) => {
    const anexos = Array.isArray(mensagem?.anexos) ? mensagem.anexos : [];

    if (!anexos.length) return null;

    return (
      <MDBox mt={1} display="flex" flexDirection="column" gap={0.75}>
        {anexos.map((anexo) => {
          const href = anexo.url || anexo.caminho_relativo || "#";
          const isImagem = isImagemAnexo(anexo);

          return (
            <MDBox
              key={anexo.id}
              component="a"
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                display: "block",
                textDecoration: "none",
                border: "1px solid rgba(0,0,0,0.08)",
                borderRadius: 1,
                px: 1,
                py: 0.75,
                backgroundColor: "rgba(25,118,210,0.04)",
                cursor: anexo.url || anexo.caminho_relativo ? "pointer" : "default",
              }}
            >
              <MDBox display="flex" alignItems="center" gap={1}>
                {isImagem ? (
                  <MDBox
                    sx={{
                      width: 42,
                      height: 42,
                      borderRadius: 0.75,
                      overflow: "hidden",
                      border: "1px solid rgba(0,0,0,0.08)",
                      backgroundColor: "#f5f5f5",
                      flexShrink: 0,
                    }}
                  >
                    <img
                      src={href}
                      alt={anexo.nome_original || anexo.nome_fisico || "Imagem"}
                      loading="lazy"
                      decoding="async"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        display: "block",
                      }}
                    />
                  </MDBox>
                ) : (
                  <MDBox
                    sx={{
                      width: 42,
                      height: 42,
                      borderRadius: 0.75,
                      border: "1px solid rgba(0,0,0,0.08)",
                      backgroundColor: "#f8f9fb",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <DescriptionIcon sx={{ color: "#7b809a", fontSize: 20 }} />
                  </MDBox>
                )}

                <MDBox sx={{ minWidth: 0, flex: 1 }}>
                  <MDTypography
                    variant="caption"
                    fontWeight="medium"
                    sx={{
                      display: "block",
                      color: "#1976d2",
                      wordBreak: "break-word",
                    }}
                  >
                    {anexo.nome_original || anexo.nome_fisico || "Anexo"}
                  </MDTypography>

                  <MDTypography
                    variant="caption"
                    sx={{
                      display: "block",
                      color: "#7b809a",
                      mt: 0.25,
                    }}
                  >
                    {formatarTamanhoBytes(anexo.tamanho_bytes)}
                    {anexo.extensao
                      ? ` • ${String(anexo.extensao).replace(".", "").toUpperCase()}`
                      : ""}
                  </MDTypography>
                </MDBox>
              </MDBox>
            </MDBox>
          );
        })}
      </MDBox>
    );
  };

  useEffect(() => {
    try {
      const ua = String(navigator.userAgent || "");
      const isMobile = /iPhone|iPad|iPod|Android/i.test(ua);
      setCanCamera(isMobile);
    } catch {
      setCanCamera(false);
    }
  }, []);

  useEffect(() => {
    if (erroVoz) {
      showAlert(`Erro no reconhecimento de voz: ${erroVoz}`, "warning");
    }
  }, [erroVoz, showAlert]);

  useEffect(() => {
    carregarChats();
  }, [userData?.id]);

  useEffect(() => {
    if (!userData?.id) return;

    let cancelado = false;

    const initSignalR = async () => {
      const conn = await startConnection(localStorage.getItem("token"));

      if (cancelado || !conn) return;

      // console.log("SignalR estado após startConnection:", conn.state);

      if (conn.state === "Connected") {
        setSignalRPronto(true);

        await conn.invoke("RegistarUtilizador", Number(userData.id));
        // console.log("SignalR utilizador registado:", userData.id);

        // A entrada/saída do grupo do chat é tratada no useEffect dedicado a chatSelecionado?.id
      }
    };

    initSignalR();

    return () => {
      cancelado = true;
    };
  }, [userData?.id]);

  useEffect(() => {
    if (!chatSelecionado?.id) return;

    const conn = getConnection();

    // console.log("SignalR tentativa EntrarChat:", {
    //   idchat: chatSelecionado.id,
    //   estado: conn?.state,
    // });

    if (!conn || conn.state !== "Connected") return;

    conn
      .invoke("EntrarChat", Number(chatSelecionado.id))
      //   .then(() => console.log("SignalR entrou no chat:", chatSelecionado.id))
      .then(() => {})
      .catch((err) => console.error("Erro SignalR EntrarChat:", err));

    return () => {
      // Não sair do grupo ao trocar de chat.
      // A página deve manter ligação aos grupos de todos os chats visíveis
      // para receber NovaMensagem e atualizar a lista lateral em tempo real.
    };
  }, [chatSelecionado?.id]);

  useEffect(() => {
    if (!signalRPronto || !Array.isArray(chats) || chats.length === 0) return;

    const conn = getConnection();

    if (!conn || conn.state !== "Connected") return;

    chats.forEach((chat) => {
      if (!chat?.id) return;

      conn
        .invoke("EntrarChat", Number(chat.id))
        .then(() => {})
        .catch((err) => console.error("Erro SignalR EntrarChat lista:", err));
    });
  }, [signalRPronto, chats]);

  useEffect(() => {
    if (!signalRPronto) {
      //   console.log("SignalR listener NovaMensagem ainda não registado: signalRPronto=false");
      return;
    }

    const conn = getConnection();

    // console.log("SignalR registo listeners Chats:", {
    //   estado: conn?.state,
    //   idchat: chatSelecionado?.id,
    // });

    if (!conn || conn.state !== "Connected") return;

    const receberNovaMensagem = async (payload) => {
      //   console.log("SignalR NovaMensagem recebida:", payload);

      const idChatEvento = payload?.idchat;

      if (!idChatEvento) return;

      await carregarChats();

      if (String(idChatEvento) === String(chatSelecionado?.id)) {
        setMensagens((prev) => {
          if (!Array.isArray(prev)) return [payload];

          if (prev.some((m) => Number(m.id) === Number(payload.id))) return prev;

          return [...prev, payload];
        });

        await marcarChatComoLido(chatSelecionado.id);
      }
    };

    const receberNovoAnexoMensagem = async (payload) => {
      //   console.log("SignalR NovoAnexoMensagem recebido:", payload);

      const idChatEvento = payload?.idchat;
      const idMensagemEvento = payload?.idmensagem;

      if (!idChatEvento || !idMensagemEvento) return;

      await carregarChats();

      if (String(idChatEvento) !== String(chatSelecionado?.id)) return;

      setMensagens((prev) => {
        if (!Array.isArray(prev)) return prev;

        return prev.map((mensagem) => {
          if (Number(mensagem.id) !== Number(idMensagemEvento)) return mensagem;

          const anexosAtuais = Array.isArray(mensagem.anexos) ? mensagem.anexos : [];

          if (anexosAtuais.some((a) => Number(a.id) === Number(payload.id))) return mensagem;

          return {
            ...mensagem,
            anexos: [...anexosAtuais, payload],
            total_anexos: Number(mensagem.total_anexos || 0) + 1,
          };
        });
      });
    };

    const receberReacaoMensagem = (payload) => {
      if (!payload?.idmensagem) return;

      scrollTopAntesReacaoRef.current = mensagensRef.current?.scrollTop ?? null;
      ignorarScrollDepoisRefreshRef.current = true;

      setMensagens((prev) => {
        if (!Array.isArray(prev)) return prev;

        return prev.map((m) => {
          if (Number(m.id) !== Number(payload.idmensagem)) return m;

          const reacaoPayload = String(payload.reacao || "");
          const isMeuEvento = String(payload.idutilizador) === String(userData?.id);

          let novasReacoes = Array.isArray(m.reacoes) ? m.reacoes.map((r) => ({ ...r })) : [];

          const reacaoAnteriorPayload = payload.reacao_anterior || payload.reacaoAnterior || null;

          if (
            !payload.removida &&
            reacaoAnteriorPayload &&
            reacaoAnteriorPayload !== reacaoPayload
          ) {
            novasReacoes = novasReacoes
              .map((r) => {
                if (String(r.reacao) !== String(reacaoAnteriorPayload)) return r;

                return {
                  ...r,
                  total: Math.max(0, Number(r.total || 0) - 1),
                  minha_reacao: isMeuEvento ? false : r.minha_reacao,
                };
              })
              .filter((r) => Number(r.total || 0) > 0);
          }

          if (payload.removida) {
            novasReacoes = novasReacoes
              .map((r) => {
                if (String(r.reacao) !== reacaoPayload) return r;

                return {
                  ...r,
                  total: Math.max(0, Number(r.total || 0) - 1),
                  minha_reacao: isMeuEvento ? false : r.minha_reacao,
                };
              })
              .filter((r) => Number(r.total || 0) > 0);

            return {
              ...m,
              reacoes: novasReacoes,
            };
          }

          if (isMeuEvento) {
            novasReacoes = novasReacoes
              .map((r) => {
                const eraMinhaReacao = r.minha_reacao === true || Number(r.minha_reacao) === 1;

                if (!eraMinhaReacao || String(r.reacao) === reacaoPayload) return r;

                return {
                  ...r,
                  total: Math.max(0, Number(r.total || 0) - 1),
                  minha_reacao: false,
                };
              })
              .filter((r) => Number(r.total || 0) > 0);
          }

          const existente = novasReacoes.find((r) => String(r.reacao) === reacaoPayload);

          if (existente) {
            existente.total = Number(existente.total || 0) + 1;

            if (isMeuEvento) {
              existente.minha_reacao = true;
            }
          } else {
            novasReacoes.push({
              reacao: reacaoPayload,
              total: 1,
              minha_reacao: isMeuEvento,
            });
          }

          return {
            ...m,
            reacoes: novasReacoes,
          };
        });
      });
    };

    const receberChatsAtualizados = async () => {
      await carregarChats();
    };

    const receberChatMarcadoComoLido = async (payload) => {
      if (!payload?.idchat || !payload?.idutilizador) return;

      await carregarChats();

      if (String(payload.idchat) !== String(chatSelecionado?.id)) return;

      const idUltimaMensagemLida = Number(payload.idultima_mensagem_lida || 0);
      const isMeuEvento = String(payload.idutilizador) === String(userData?.id);

      setMensagens((prev) => {
        if (!Array.isArray(prev)) return prev;

        return prev.map((m) => {
          const dentroLimite =
            !idUltimaMensagemLida || Number(m.id) <= Number(idUltimaMensagemLida);

          if (!dentroLimite) return m;

          if (isMeuEvento) {
            if (String(m.idutilizador) === String(userData?.id)) return m;

            return {
              ...m,
              lida_pelo_utilizador: true,
            };
          }

          if (String(m.idutilizador) !== String(userData?.id)) return m;

          const totalDestinatarios = Number(m.total_destinatarios || 0);
          const totalLidasAtual = Number(m.total_lidas || 0);

          return {
            ...m,
            total_lidas:
              totalDestinatarios > 0
                ? Math.min(totalDestinatarios, totalLidasAtual + 1)
                : totalLidasAtual + 1,
          };
        });
      });
    };

    conn.off("NovaMensagem");
    conn.off("NovoAnexoMensagem");
    conn.off("ReacaoMensagemAlterada");
    conn.off("ChatMarcadoComoLido");
    conn.off("ChatsAtualizados");

    conn.on("NovaMensagem", receberNovaMensagem);
    conn.on("NovoAnexoMensagem", receberNovoAnexoMensagem);
    conn.on("ReacaoMensagemAlterada", receberReacaoMensagem);
    conn.on("ChatMarcadoComoLido", receberChatMarcadoComoLido);
    conn.on("ChatsAtualizados", receberChatsAtualizados);

    const receberEscrever = (payload) => {
      if (String(payload?.idchat) !== String(chatSelecionado?.id)) return;
      if (String(payload?.idutilizador) === String(userData?.id)) return;

      setUtilizadoresAEscrever((prev) => {
        const jaExiste = prev.some((u) => Number(u.idutilizador) === Number(payload.idutilizador));

        if (jaExiste) {
          return prev.map((u) =>
            Number(u.idutilizador) === Number(payload.idutilizador)
              ? { ...u, nome: payload.nome || u.nome }
              : u
          );
        }

        return [
          ...prev,
          {
            idutilizador: payload.idutilizador,
            nome: payload.nome || "Utilizador",
          },
        ];
      });
    };

    const receberPararEscrever = (payload) => {
      if (String(payload?.idchat) !== String(chatSelecionado?.id)) return;

      setUtilizadoresAEscrever((prev) =>
        prev.filter((u) => Number(u.idutilizador) !== Number(payload.idutilizador))
      );
    };

    conn.off("UtilizadorAEscrever");
    conn.off("UtilizadorParouEscrever");

    conn.on("UtilizadorAEscrever", receberEscrever);
    conn.on("UtilizadorParouEscrever", receberPararEscrever);

    return () => {
      conn.off("NovaMensagem", receberNovaMensagem);
      conn.off("NovoAnexoMensagem", receberNovoAnexoMensagem);
      conn.off("ReacaoMensagemAlterada", receberReacaoMensagem);
      conn.off("ChatMarcadoComoLido", receberChatMarcadoComoLido);
      conn.off("ChatsAtualizados", receberChatsAtualizados);
      conn.off("UtilizadorAEscrever", receberEscrever);
      conn.off("UtilizadorParouEscrever", receberPararEscrever);
    };
  }, [signalRPronto, chatSelecionado?.id, userData?.id]);

  useEffect(() => {
    const abrirChat = async () => {
      if (chatSelecionado?.id) {
        setUtilizadoresAEscrever([]);
        setMensagemEmResposta(null);
        setMensagemEmEdicao(null);
        setMenuMencoesOpen(false);
        setTextoMencaoAtual("");
        setMencoesSelecionadas([]);
        setIndiceMencaoAtiva(0);
        setTextoMensagem("");
        setTextoPesquisaChat("");
        setResultadosPesquisaChat([]);

        await carregarMembrosChat(chatSelecionado.id);
        await carregarMensagens(chatSelecionado.id);
      }
    };

    abrirChat();
  }, [chatSelecionado?.id]);

  useEffect(() => {
    if (loadingMensagens || mensagens.length === 0) return;

    requestAnimationFrame(() => {
      if (ignorarScrollDepoisRefreshRef.current) {
        const scrollTopAntes = scrollTopAntesReacaoRef.current;

        requestAnimationFrame(() => {
          if (mensagensRef.current && scrollTopAntes !== null) {
            mensagensRef.current.scrollTop = scrollTopAntes;
          }

          ignorarScrollDepoisRefreshRef.current = false;
          scrollTopAntesReacaoRef.current = null;
          primeiraNaoLidaRef.current = null;
        });

        return;
      }

      if (mensagemGlobalPendente) {
        irParaMensagem(mensagemGlobalPendente);
        setMensagemGlobalPendente(null);
        return;
      }

      if (idmensagem) {
        primeiraNaoLidaRef.current = null;

        const tentarIrParaMensagemUrl = () => {
          const el = document.getElementById(`mensagem-${idmensagem}`);

          if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "center" });

            setMensagemHighlight(Number(idmensagem));

            setTimeout(() => {
              setMensagemHighlight(null);
            }, 2200);

            return true;
          }

          return false;
        };

        if (tentarIrParaMensagemUrl()) return;

        setTimeout(() => {
          tentarIrParaMensagemUrl();
        }, 300);

        return;
      }

      scrollParaPrimeiraNaoLidaOuFim("auto");
    });
  }, [mensagens, idmensagem, loadingMensagens, navigate, idchat]);

  const anexosChatAtual = useMemo(() => {
    const lista = [];
    const meses = Number(filtroAnexosMeses || 0);

    const dataLimite = meses > 0 ? new Date() : null;
    if (dataLimite) {
      dataLimite.setMonth(dataLimite.getMonth() - meses);
    }

    mensagens.forEach((mensagem) => {
      const anexos = Array.isArray(mensagem?.anexos) ? mensagem.anexos : [];

      anexos.forEach((anexo) => {
        const dataAnexo = anexo.datahora_upload
          ? new Date(anexo.datahora_upload)
          : mensagem.datahora_envio
          ? new Date(mensagem.datahora_envio)
          : null;

        if (dataLimite && dataAnexo && dataAnexo < dataLimite) return;

        lista.push({
          ...anexo,
          idmensagem: mensagem.id,
          textoMensagem: mensagem.texto || "",
          utilizador_designacao: mensagem.utilizador_designacao || "",
          datahora_envio: mensagem.datahora_envio,
        });
      });
    });

    return lista.sort((a, b) => {
      const da = new Date(a.datahora_upload || a.datahora_envio || 0).getTime();
      const db = new Date(b.datahora_upload || b.datahora_envio || 0).getTime();

      return db - da;
    });
  }, [mensagens, filtroAnexosMeses]);

  useEffect(() => {
    let cancelado = false;

    const carregarPreviewsTexto = async () => {
      const anexosTexto = anexosChatAtual.filter((anexo) => {
        const chave = `${anexo.idmensagem}-${anexo.id}`;
        return (
          isTextoSimplesAnexo(anexo) &&
          !previewTextoPorAnexo[chave] &&
          !!(anexo.url || anexo.caminho_relativo)
        );
      });

      for (const anexo of anexosTexto) {
        const chave = `${anexo.idmensagem}-${anexo.id}`;
        const href = anexo.url || anexo.caminho_relativo;

        try {
          const resp = await fetch(href);
          const texto = await resp.text();

          if (cancelado) return;

          setPreviewTextoPorAnexo((prev) => ({
            ...prev,
            [chave]: (texto || "").replace(/\s+/g, " ").trim().slice(0, 220),
          }));
        } catch {
          if (cancelado) return;

          setPreviewTextoPorAnexo((prev) => ({
            ...prev,
            [chave]: "",
          }));
        }
      }
    };

    if (anexosChatAtual.length > 0) {
      carregarPreviewsTexto();
    }

    return () => {
      cancelado = true;
    };
  }, [anexosChatAtual, previewTextoPorAnexo]);

  return (
    <>
      <style>
        {`
.typing-dots::after {
  content: "...";
  animation: typingDots 1.5s infinite;
}

@keyframes typingDots {
  0% { content: "."; }
  33% { content: ".."; }
  66% { content: "..."; }
  100% { content: "."; }
}
`}
      </style>

      <DashboardLayout>
        <DashboardNavbar />

        {loading && (
          <MDBox py={2} display="flex" alignItems="center" justifyContent="center">
            <CircularProgress />
          </MDBox>
        )}

        <PageHeader title="Chats" subtitle="Comunicação interna em tempo real" />

        <MDBox pt={1}>
          <Card
            sx={{
              overflow: "hidden",
              height: { xs: "auto", lg: "calc(100vh - 245px)" },
              minHeight: { xs: "auto", lg: 0 },
            }}
          >
            <MDBox
              p={2}
              display="flex"
              flexDirection="column"
              sx={{ height: "100%", minHeight: 0, overflow: "hidden" }}
            >
              <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <MDTypography variant="h6">Comunicação</MDTypography>

                <MDBox display="flex" gap={1}>
                  <MDButton color="info" onClick={handleOpenNovoChat}>
                    Novo Chat
                  </MDButton>
                  <MDButton color="secondary" onClick={carregarChats}>
                    Atualizar
                  </MDButton>
                </MDBox>
              </MDBox>

              <MDBox
                display="grid"
                gridTemplateColumns={{ xs: "1fr", lg: "320px minmax(0, 1fr) 240px" }}
                gap={2}
                sx={{
                  flex: 1,
                  minHeight: 0,
                  overflow: { xs: "visible", lg: "visible" },
                }}
              >
                <Card
                  ref={blocoChatsRef}
                  sx={{
                    border: "1px solid rgba(0,0,0,0.06)",
                    boxShadow: "none",
                    height: { xs: "auto", lg: "100%" },
                    minHeight: 0,
                    backgroundColor: "#f5f6f8",

                    display: { xs: openMobileChats ? "block" : "none", lg: "block" },
                    position: { xs: "fixed", lg: "static" },
                    left: { xs: 16, lg: "auto" },
                    right: { xs: 16, lg: "auto" },
                    top: { xs: 110, lg: "auto" },
                    bottom: { xs: 110, lg: "auto" },
                    zIndex: { xs: 1300, lg: "auto" },
                  }}
                >
                  <MDBox
                    p={2}
                    sx={{
                      height: "100%",
                      overflow: "hidden",
                      minHeight: 0,
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <MDBox display="flex" alignItems="center" gap={0.75}>
                      <IconButton
                        size="small"
                        onClick={() => setOpenMobileChats(false)}
                        sx={{
                          display: { xs: "inline-flex", lg: "none" },
                          width: 28,
                          height: 28,
                          color: "#344767",
                        }}
                      >
                        <Icon>arrow_back</Icon>
                      </IconButton>

                      <MDTypography variant="button" color="text" fontWeight="medium">
                        Chats
                      </MDTypography>
                    </MDBox>

                    <MDBox mt={1.5} display="flex" alignItems="center" gap={0.5}>
                      <TextField
                        size="small"
                        fullWidth
                        placeholder="Pesquisar em todos os chats"
                        value={textoPesquisaGlobal}
                        onChange={(e) => setTextoPesquisaGlobal(e.target.value)}
                        onKeyDown={async (e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                            await pesquisarMensagensGlobal();
                          }
                        }}
                      />

                      <Tooltip title="Pesquisar em todos os chats">
                        <span>
                          <IconButton
                            size="small"
                            disabled={loadingPesquisaGlobal}
                            onClick={pesquisarMensagensGlobal}
                          >
                            <Icon>search</Icon>
                          </IconButton>
                        </span>
                      </Tooltip>

                      <Tooltip title="Limpar pesquisa global">
                        <span>
                          <IconButton
                            size="small"
                            disabled={!textoPesquisaGlobal}
                            onClick={() => {
                              setTextoPesquisaGlobal("");
                              setResultadosPesquisaGlobal([]);
                            }}
                          >
                            <Icon>close</Icon>
                          </IconButton>
                        </span>
                      </Tooltip>
                    </MDBox>

                    <MDBox
                      mt={2}
                      display="flex"
                      flexDirection="column"
                      gap={1}
                      sx={{
                        flex: 1,
                        minHeight: 0,
                        overflowY: "auto",
                      }}
                    >
                      {chats.length === 0 && !loading && (
                        <MDTypography variant="caption" color="text">
                          Sem chats disponíveis.
                        </MDTypography>
                      )}

                      {chats.map((chat) => {
                        const ativo = String(chatSelecionado?.id) === String(chat.id);

                        return (
                          <MDBox
                            key={chat.id}
                            onClick={() => {
                              setChatSelecionado(chat);
                              setOpenMobileChats(false);
                            }}
                            sx={{
                              p: 1.25,
                              borderRadius: 1.5,
                              cursor: "pointer",
                              border: ativo
                                ? "1px solid rgba(25, 118, 210, 0.35)"
                                : "1px solid rgba(0,0,0,0.08)",
                              backgroundColor: ativo ? "rgba(25, 118, 210, 0.06)" : "#fff",
                            }}
                          >
                            <MDBox
                              display="flex"
                              justifyContent="space-between"
                              alignItems="flex-start"
                              gap={1}
                            >
                              <MDTypography
                                variant="button"
                                fontWeight="medium"
                                sx={{ lineHeight: 1.2 }}
                              >
                                {chat.designacao}
                              </MDTypography>

                              {!!chat.total_nao_lidas && (
                                <MDBox
                                  px={0.8}
                                  py={0.15}
                                  borderRadius="999px"
                                  sx={{
                                    fontSize: 11,
                                    fontWeight: 700,
                                    backgroundColor: "#1976d2",
                                    color: "#fff",
                                    minWidth: 20,
                                    textAlign: "center",
                                  }}
                                >
                                  {chat.total_nao_lidas}
                                </MDBox>
                              )}
                            </MDBox>

                            <MDTypography
                              variant="caption"
                              color="text"
                              sx={{
                                display: "block",
                                mt: 0.5,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {chat.ultima_mensagem_texto ||
                                chat.descricao ||
                                "Sem mensagens ainda."}
                            </MDTypography>
                          </MDBox>
                        );
                      })}
                    </MDBox>
                  </MDBox>
                </Card>

                <Card
                  sx={{
                    border: "1px solid rgba(0,0,0,0.06)",
                    boxShadow: "none",
                    height: { xs: "calc(100dvh - 250px)", lg: "100%" },
                    minHeight: 0,
                    backgroundColor: "#f5f6f8",
                  }}
                >
                  <MDBox
                    p={2}
                    display="flex"
                    flexDirection="column"
                    sx={{
                      height: "100%",
                      overflow: { xs: "hidden", lg: "visible" },
                      minHeight: 0,
                    }}
                  >
                    <MDBox display="flex" flexDirection="column" gap={1}>
                      <MDBox
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        gap={1}
                      >
                        <MDTypography variant="button" color="text" fontWeight="medium">
                          {chatSelecionado?.designacao || "Mensagens"}
                        </MDTypography>

                        {chatSelecionado?.id && (
                          <Tooltip title="Membros">
                            <IconButton size="small" onClick={handleOpenMembrosChat}>
                              <Icon>people</Icon>
                            </IconButton>
                          </Tooltip>
                        )}
                      </MDBox>

                      {chatSelecionado?.id && (
                        <MDBox display="flex" alignItems="center" gap={1}>
                          <TextField
                            size="small"
                            fullWidth
                            placeholder="Pesquisar no chat atual (vários termos = todos obrigatórios)"
                            value={textoPesquisaChat}
                            onChange={(e) => setTextoPesquisaChat(e.target.value)}
                            onKeyDown={async (e) => {
                              if (e.key === "Enter") {
                                e.preventDefault();
                                await pesquisarMensagensChat();
                              }
                            }}
                          />

                          <Tooltip title="Pesquisar">
                            <span>
                              <IconButton
                                size="small"
                                onClick={pesquisarMensagensChat}
                                disabled={loadingPesquisaChat}
                              >
                                <Icon>search</Icon>
                              </IconButton>
                            </span>
                          </Tooltip>

                          <Tooltip title="Limpar pesquisa">
                            <span>
                              <IconButton
                                size="small"
                                disabled={!textoPesquisaChat}
                                onClick={() => {
                                  setTextoPesquisaChat("");
                                  setResultadosPesquisaChat([]);
                                }}
                              >
                                <Icon>close</Icon>
                              </IconButton>
                            </span>
                          </Tooltip>
                        </MDBox>
                      )}
                    </MDBox>

                    <Divider sx={{ my: 1.5 }} />

                    <MDBox
                      ref={mensagensRef}
                      onScroll={handleScrollMensagens}
                      sx={{
                        flex: 1,
                        height: "auto",
                        minHeight: 0,
                        borderRadius: 1.5,
                        background: "#eef1f5",
                        p: 2,
                        pb: { xs: "90px", sm: "90px", lg: 2 },
                        display: "flex",
                        flexDirection: "column",
                        gap: 1,
                        overflowY: "auto",
                      }}
                    >
                      {loadingMensagens && (
                        <MDBox display="flex" justifyContent="center" py={2}>
                          <CircularProgress size={24} />
                        </MDBox>
                      )}

                      {!loadingMensagens && mensagens.length === 0 && (
                        <MDTypography variant="caption" color="text">
                          Sem mensagens neste chat.
                        </MDTypography>
                      )}

                      {!loadingMensagens &&
                        mensagens.map((m) => {
                          const isMe = String(m.idutilizador) === String(userData.id);

                          return (
                            <MDBox
                              key={m.id}
                              id={`mensagem-${m.id}`}
                              display="flex"
                              justifyContent={isMe ? "flex-end" : "flex-start"}
                              alignItems="flex-end"
                              gap={0.75}
                            >
                              {!isMe &&
                                renderAvatarUtilizador(
                                  { id: m.idutilizador, designacao: m.utilizador_designacao },
                                  28
                                )}

                              <MDBox
                                sx={{
                                  maxWidth: { xs: "92%", sm: "85%", md: "75%", lg: "70%" },
                                  px: { xs: 1, sm: 1.5 },
                                  py: 1,
                                  borderRadius: 1.5,
                                  backgroundColor: isMe ? "#d9fdd3" : "#fff",
                                  color: "#333",
                                  border:
                                    Number(mensagemHighlight) === Number(m.id)
                                      ? "2px solid #1976d2"
                                      : "1px solid rgba(0,0,0,0.08)",
                                  boxShadow:
                                    Number(mensagemHighlight) === Number(m.id)
                                      ? "0 0 0 2px rgba(25,118,210,0.18)"
                                      : "0 1px 1px rgba(0,0,0,0.05)",
                                  transition: "all 0.25s ease",
                                }}
                              >
                                {!isMe && (
                                  <MDTypography
                                    variant="caption"
                                    fontWeight="medium"
                                    sx={{ display: "block", mb: 0.3 }}
                                  >
                                    {m.utilizador_designacao}
                                  </MDTypography>
                                )}

                                {m.idmensagem_pai && (
                                  <MDBox
                                    sx={{
                                      fontSize: 11,
                                      opacity: 0.7,
                                      mb: 0.5,
                                      borderLeft: "2px solid rgba(0,0,0,0.2)",
                                      pl: 0.8,
                                    }}
                                  >
                                    {m.mensagem_pai_utilizador_designacao}: {m.mensagem_pai_texto}
                                  </MDBox>
                                )}

                                <MDTypography
                                  variant="caption"
                                  sx={{
                                    display: "block",
                                    whiteSpace: "pre-wrap",
                                    wordBreak: "break-word",
                                  }}
                                >
                                  {renderTextoComMencoes(m.texto)}
                                </MDTypography>

                                {renderAnexosMensagem(m)}

                                {Array.isArray(m.reacoes) && m.reacoes.length > 0 && (
                                  <MDBox
                                    mt={0.5}
                                    display="flex"
                                    flexWrap="wrap"
                                    gap={0.5}
                                    sx={{ justifyContent: isMe ? "flex-end" : "flex-start" }}
                                  >
                                    <MDBox
                                      component="button"
                                      type="button"
                                      onClick={() => abrirDetalheReacoes(m)}
                                      px={0.75}
                                      py={0.25}
                                      sx={{
                                        borderRadius: "12px",
                                        fontSize: 12,
                                        backgroundColor: "rgba(25,118,210,0.12)",
                                        border: "1px solid rgba(25,118,210,0.35)",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 0.5,
                                        cursor: "pointer",
                                        fontFamily: "inherit",
                                        fontWeight: 700,
                                      }}
                                    >
                                      <span>Reações</span>
                                      <span>
                                        {m.reacoes.reduce(
                                          (total, r) => total + Number(r.total || 0),
                                          0
                                        )}
                                      </span>
                                    </MDBox>
                                    {m.reacoes.map((r, idx) => (
                                      <MDBox
                                        key={idx}
                                        component="button"
                                        type="button"
                                        onClick={() => abrirDetalheReacoes(m)}
                                        px={0.75}
                                        py={0.25}
                                        sx={{
                                          borderRadius: "12px",
                                          fontSize: 12,
                                          backgroundColor: r.minha_reacao
                                            ? "rgba(25,118,210,0.15)"
                                            : "rgba(0,0,0,0.05)",
                                          border: r.minha_reacao
                                            ? "1px solid rgba(25,118,210,0.4)"
                                            : "1px solid rgba(0,0,0,0.08)",
                                          display: "flex",
                                          alignItems: "center",
                                          gap: 0.5,
                                          cursor: "pointer",
                                          fontFamily: "inherit",
                                          "&:hover": {
                                            backgroundColor: "rgba(25,118,210,0.12)",
                                          },
                                        }}
                                      >
                                        <span>{r.reacao}</span>
                                        <span>{r.total}</span>
                                      </MDBox>
                                    ))}
                                  </MDBox>
                                )}

                                <MDBox
                                  mt={0.5}
                                  display="flex"
                                  justifyContent="flex-end"
                                  alignItems="center"
                                  sx={{ opacity: 0.6 }}
                                >
                                  <MDTypography variant="caption">
                                    {new Date(m.datahora_envio).toLocaleTimeString()}
                                    {m.editada ? " (editada)" : ""}
                                  </MDTypography>

                                  {renderEstadoLeituraMensagem(m, isMe)}
                                </MDBox>

                                <MDBox
                                  mt={0.5}
                                  display="flex"
                                  justifyContent="flex-start"
                                  alignItems="center"
                                  gap={0.5}
                                >
                                  {isMe && Number(m.total_lidas || 0) === 0 && (
                                    <>
                                      <Tooltip title="Editar">
                                        <IconButton
                                          size="small"
                                          onClick={() => iniciarEdicaoMensagem(m)}
                                        >
                                          <EditIcon sx={{ fontSize: 16 }} />
                                        </IconButton>
                                      </Tooltip>

                                      <Tooltip title="Apagar">
                                        <IconButton size="small" onClick={() => apagarMensagem(m)}>
                                          <DeleteIcon sx={{ fontSize: 16, color: "#d32f2f" }} />
                                        </IconButton>
                                      </Tooltip>
                                    </>
                                  )}

                                  {!isMe && (
                                    <MDBox sx={{ position: "relative" }}>
                                      <Tooltip title="Reagir">
                                        <IconButton
                                          size="small"
                                          onClick={() =>
                                            setMensagemReacaoOpen((prev) =>
                                              Number(prev) === Number(m.id) ? null : m.id
                                            )
                                          }
                                        >
                                          <ThumbUpAltOutlinedIcon sx={{ fontSize: 16 }} />
                                        </IconButton>
                                      </Tooltip>

                                      {Number(mensagemReacaoOpen) === Number(m.id) && (
                                        <MDBox
                                          sx={{
                                            position: "fixed",
                                            left: { xs: 16, md: "50%" },
                                            transform: { xs: "none", md: "translateX(-50%)" },
                                            bottom: { xs: 120, md: 140 },
                                            zIndex: 2001,
                                            display: "flex",
                                            gap: 0.5,
                                            px: 0.75,
                                            py: 0.5,
                                            borderRadius: "18px",
                                            backgroundColor: "#fff",
                                            boxShadow: "0 4px 14px rgba(0,0,0,0.18)",
                                            border: "1px solid rgba(0,0,0,0.08)",
                                          }}
                                        >
                                          {["👍", "❤️", "😂", "😮", "😢", "😡"].map((emoji) => (
                                            <MDBox
                                              key={emoji}
                                              component="button"
                                              onClick={async () => {
                                                setMensagemReacaoOpen(null);
                                                await reagirMensagem(m, emoji);
                                              }}
                                              sx={{
                                                width: 34,
                                                height: 34,
                                                border: "none",
                                                borderRadius: "50%",
                                                fontSize: 21,
                                                cursor: "pointer",
                                                backgroundColor: "rgba(25,118,210,0.08)",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                lineHeight: 1,
                                                opacity: 1,
                                                transition: "all 0.15s ease",
                                                "&:hover": {
                                                  backgroundColor: "rgba(25,118,210,0.16)",
                                                  transform: "scale(1.18)",
                                                },
                                              }}
                                            >
                                              {emoji}
                                            </MDBox>
                                          ))}
                                        </MDBox>
                                      )}
                                    </MDBox>
                                  )}

                                  <Tooltip title="Responder">
                                    <IconButton
                                      size="small"
                                      onClick={() => {
                                        setMensagemEmEdicao(null);
                                        setMensagemEmResposta(m);
                                      }}
                                    >
                                      <ReplyIcon sx={{ fontSize: 16 }} />
                                    </IconButton>
                                  </Tooltip>

                                  <Tooltip title="Reencaminhar para chat">
                                    <IconButton
                                      size="small"
                                      onClick={() => abrirReencaminharMensagem(m)}
                                    >
                                      <ForwardIcon sx={{ fontSize: 16 }} />
                                    </IconButton>
                                  </Tooltip>

                                  <Tooltip title="Reencaminhar por email">
                                    <IconButton
                                      size="small"
                                      onClick={async () => {
                                        setMensagemAEnviarEmail(m);
                                        setUtilizadoresEmail([]);
                                        setEmailsLivres("");
                                        await carregarUtilizadores();
                                        setOpenEnviarEmail(true);
                                      }}
                                    >
                                      <EmailIcon sx={{ fontSize: 16 }} />
                                    </IconButton>
                                  </Tooltip>
                                </MDBox>
                              </MDBox>
                              {isMe &&
                                renderAvatarUtilizador(
                                  { id: m.idutilizador, designacao: userData?.designacao },
                                  28
                                )}
                            </MDBox>
                          );
                        })}

                      <div />
                    </MDBox>

                    <MDBox
                      mt={1}
                      display="flex"
                      flexDirection="column"
                      gap={1}
                      sx={{
                        flexShrink: 0,
                        position: { xs: "sticky", lg: "static" },
                        bottom: { xs: "env(safe-area-inset-bottom)", lg: "auto" },
                        mb: { xs: "env(safe-area-inset-bottom)", lg: 0 },
                        zIndex: 5,
                        backgroundColor: "#fff",
                        border: "1px solid rgba(0,0,0,0.08)",
                        borderRadius: "18px",
                        p: 1,
                        boxShadow: { xs: "0 -2px 8px rgba(0,0,0,0.08)", lg: "none" },
                      }}
                    >
                      {mensagemEmEdicao && (
                        <MDBox
                          px={1}
                          py={0.75}
                          sx={{
                            borderLeft: "3px solid #f59e0b",
                            backgroundColor: "rgba(245,158,11,0.08)",
                            borderRadius: "8px",
                          }}
                        >
                          <MDBox
                            display="flex"
                            justifyContent="space-between"
                            alignItems="flex-start"
                            gap={1}
                          >
                            <MDBox>
                              <MDTypography
                                variant="caption"
                                fontWeight="medium"
                                sx={{ color: "#b26a00" }}
                              >
                                A editar mensagem
                              </MDTypography>

                              <MDTypography
                                variant="caption"
                                sx={{
                                  display: "block",
                                  color: "#344767",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  maxWidth: "100%",
                                }}
                              >
                                {mensagemEmEdicao.texto}
                              </MDTypography>
                            </MDBox>

                            <MDButton
                              variant="text"
                              color="secondary"
                              size="small"
                              sx={{ minWidth: "auto", px: 0.5, py: 0 }}
                              onClick={cancelarEdicaoMensagem}
                            >
                              ✕
                            </MDButton>
                          </MDBox>
                        </MDBox>
                      )}

                      {mensagemEmResposta && (
                        <MDBox
                          px={1}
                          py={0.75}
                          sx={{
                            borderLeft: "3px solid #1976d2",
                            backgroundColor: "rgba(25,118,210,0.05)",
                            borderRadius: "8px",
                          }}
                        >
                          <MDBox
                            display="flex"
                            justifyContent="space-between"
                            alignItems="flex-start"
                            gap={1}
                          >
                            <MDBox>
                              <MDTypography variant="caption" fontWeight="medium" color="info">
                                {mensagemEmResposta.utilizador_designacao}
                              </MDTypography>

                              <MDTypography
                                variant="caption"
                                sx={{
                                  display: "block",
                                  color: "#344767",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  maxWidth: "100%",
                                }}
                              >
                                {renderTextoComMencoes(mensagemEmResposta.texto)}
                              </MDTypography>
                            </MDBox>

                            <MDButton
                              variant="text"
                              color="secondary"
                              size="small"
                              sx={{ minWidth: "auto", px: 0.5, py: 0 }}
                              onClick={() => setMensagemEmResposta(null)}
                            >
                              ✕
                            </MDButton>
                          </MDBox>
                        </MDBox>
                      )}

                      {utilizadoresAEscrever.length > 0 && (
                        <MDBox px={1} pb={0.25}>
                          <MDTypography
                            variant="caption"
                            sx={{
                              display: "block",
                              color: "#1976d2",
                              fontStyle: "italic",
                              lineHeight: 1.2,
                            }}
                          >
                            {utilizadoresAEscrever.length === 1
                              ? `${utilizadoresAEscrever[0].nome} está a escrever`
                              : `${utilizadoresAEscrever.length} utilizadores estão a escrever`}

                            <span className="typing-dots" />
                          </MDTypography>
                        </MDBox>
                      )}

                      <MDBox sx={{ position: "relative", width: "100%" }}>
                        {ficheirosAnexos.length > 0 && (
                          <MDBox
                            mb={1}
                            display="flex"
                            flexDirection="column"
                            gap={0.75}
                            sx={{
                              border: "1px solid rgba(0,0,0,0.08)",
                              borderRadius: "10px",
                              p: 1,
                              backgroundColor: "rgba(25,118,210,0.03)",
                            }}
                          >
                            {anexosSelecionadosPreview.map((item, index) => {
                              const ficheiro = item.ficheiro;

                              return (
                                <MDBox
                                  key={`${ficheiro.name}-${index}`}
                                  display="flex"
                                  justifyContent="space-between"
                                  alignItems="center"
                                  gap={1}
                                >
                                  <MDBox
                                    display="flex"
                                    alignItems="center"
                                    gap={1}
                                    sx={{ minWidth: 0 }}
                                  >
                                    {item.urlPreview ? (
                                      <MDBox
                                        sx={{
                                          width: 44,
                                          height: 44,
                                          borderRadius: 1,
                                          overflow: "hidden",
                                          border: "1px solid rgba(0,0,0,0.12)",
                                          flexShrink: 0,
                                          backgroundColor: "#f5f5f5",
                                        }}
                                      >
                                        <img
                                          src={item.urlPreview}
                                          alt={ficheiro.name}
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "cover",
                                            display: "block",
                                          }}
                                        />
                                      </MDBox>
                                    ) : (
                                      <MDBox
                                        sx={{
                                          width: 44,
                                          height: 44,
                                          borderRadius: 1,
                                          border: "1px solid rgba(0,0,0,0.12)",
                                          flexShrink: 0,
                                          backgroundColor: "#f8f9fb",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                        }}
                                      >
                                        <DescriptionIcon sx={{ color: "#7b809a", fontSize: 22 }} />
                                      </MDBox>
                                    )}

                                    <MDBox sx={{ minWidth: 0 }}>
                                      <MDTypography
                                        variant="caption"
                                        fontWeight="medium"
                                        sx={{
                                          display: "block",
                                          color: "#1976d2",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          whiteSpace: "nowrap",
                                        }}
                                      >
                                        {ficheiro.name}
                                      </MDTypography>

                                      <MDTypography variant="caption" color="text">
                                        {formatarTamanhoBytes(ficheiro.size)}
                                      </MDTypography>
                                    </MDBox>
                                  </MDBox>

                                  <MDButton
                                    variant="text"
                                    color="secondary"
                                    size="small"
                                    sx={{ minWidth: "auto", px: 0.5, py: 0 }}
                                    onClick={() => removerAnexoSelecionado(index)}
                                  >
                                    ✕
                                  </MDButton>
                                </MDBox>
                              );
                            })}
                          </MDBox>
                        )}

                        {menuMencoesOpen && (
                          <MDBox
                            sx={{
                              position: "absolute",
                              left: 0,
                              right: 70,
                              bottom: "calc(100% + 8px)",
                              backgroundColor: "#fff",
                              border: "1px solid rgba(0,0,0,0.12)",
                              borderRadius: "12px",
                              boxShadow: "0 6px 18px rgba(0,0,0,0.12)",
                              overflow: "hidden",
                              zIndex: 20,
                            }}
                          >
                            {mencoesFiltradas.map((membro, index) => (
                              <MDBox
                                key={membro.id}
                                onClick={() => selecionarMencao(membro)}
                                sx={{
                                  px: 1.25,
                                  py: 1,
                                  cursor: "pointer",
                                  borderBottom: "1px solid rgba(0,0,0,0.06)",
                                  backgroundColor:
                                    index === indiceMencaoAtiva
                                      ? "rgba(25,118,210,0.10)"
                                      : "transparent",
                                  "&:last-child": { borderBottom: "none" },
                                  "&:hover": { backgroundColor: "rgba(25,118,210,0.06)" },
                                }}
                              >
                                <MDTypography variant="button" fontWeight="medium">
                                  {membro.designacao}
                                </MDTypography>
                                <MDTypography variant="caption" color="text" display="block">
                                  @{membro.username}
                                </MDTypography>
                              </MDBox>
                            ))}
                          </MDBox>
                        )}

                        {openEmojiPicker && (
                          <MDBox
                            sx={{
                              position: "fixed",
                              left: { xs: 10, md: "50%" },
                              transform: { xs: "none", md: "translateX(-50%)" },
                              bottom: { xs: 80, md: 100 },
                              zIndex: 2000,
                            }}
                          >
                            <EmojiPicker
                              onEmojiClick={(emojiData) => {
                                setTextoMensagem((prev) => (prev || "") + emojiData.emoji);
                              }}
                              width={320}
                              height={420}
                            />
                          </MDBox>
                        )}

                        <MDBox
                          display="flex"
                          alignItems="flex-end"
                          sx={{
                            width: "100%",
                            flexWrap: { xs: "wrap", sm: "nowrap" },
                            gap: { xs: 0.5, sm: 0 },
                          }}
                        >
                          <input
                            ref={inputAnexosRef}
                            type="file"
                            multiple
                            style={{ display: "none" }}
                            onChange={handleSelecionarAnexos}
                          />

                          <input
                            ref={inputCameraRef}
                            type="file"
                            accept="image/*"
                            capture="environment"
                            style={{
                              position: "absolute",
                              left: "-9999px",
                              width: 1,
                              height: 1,
                              opacity: 0,
                              pointerEvents: "none",
                            }}
                            onChange={handleSelecionarAnexos}
                          />

                          <MDBox
                            display="flex"
                            alignItems="center"
                            sx={{
                              gap: 0,
                              mr: 0.25,
                              flexShrink: 0,
                            }}
                          >
                            <IconButton
                              onClick={() => inputAnexosRef.current?.click()}
                              disabled={!chatSelecionado || enviandoMensagem || !!mensagemEmEdicao}
                              sx={{
                                width: 40,
                                height: 40,
                                color: "#1976d2",
                              }}
                              title="Anexar ficheiros"
                            >
                              <AttachFileIcon sx={{ fontSize: 22 }} />
                            </IconButton>

                            <IconButton
                              onClick={() => setOpenEmojiPicker((prev) => !prev)}
                              disabled={!chatSelecionado || enviandoMensagem || !!mensagemEmEdicao}
                              sx={{
                                width: 40,
                                height: 40,
                                color: "#1976d2",
                              }}
                              title="Emojis"
                            >
                              <EmojiEmotionsIcon sx={{ fontSize: 22 }} />
                            </IconButton>

                            <Tooltip
                              title={
                                !canCamera
                                  ? "Câmara não disponível neste dispositivo/browser"
                                  : "Capturar imagem"
                              }
                            >
                              <span>
                                <IconButton
                                  onClick={() => inputCameraRef.current?.click()}
                                  disabled={
                                    !canCamera ||
                                    !chatSelecionado ||
                                    enviandoMensagem ||
                                    !!mensagemEmEdicao
                                  }
                                  sx={{
                                    width: 40,
                                    height: 40,
                                    color: canCamera ? "#1976d2" : "#bdbdbd",
                                  }}
                                >
                                  <PhotoCameraIcon sx={{ fontSize: 21 }} />
                                </IconButton>
                              </span>
                            </Tooltip>
                            <MDBox display="flex" alignItems="center">
                              <Tooltip
                                title={
                                  !suporteVoz
                                    ? "Ditado suportado apenas no Chrome"
                                    : reconhecendoVoz
                                    ? "A gravar… clique para parar"
                                    : "Ditado por voz"
                                }
                              >
                                <span>
                                  <IconButton
                                    onClick={reconhecendoVoz ? pararVoz : iniciarVoz}
                                    disabled={
                                      !suporteVoz ||
                                      !chatSelecionado ||
                                      enviandoMensagem ||
                                      !!mensagemEmEdicao
                                    }
                                    sx={{
                                      width: 40,
                                      height: 40,
                                      color: reconhecendoVoz
                                        ? "#d32f2f"
                                        : suporteVoz
                                        ? "#1976d2"
                                        : "#bdbdbd",
                                    }}
                                  >
                                    {reconhecendoVoz ? (
                                      <StopCircleIcon sx={{ fontSize: 22 }} />
                                    ) : (
                                      <MicIcon sx={{ fontSize: 22 }} />
                                    )}
                                  </IconButton>
                                </span>
                              </Tooltip>

                              <Tooltip title="Comandos de voz">
                                <span>
                                  <IconButton
                                    onClick={() => setOpenInfoVoz(true)}
                                    sx={{
                                      width: 34,
                                      height: 40,
                                      color: "#7b809a",
                                    }}
                                  >
                                    <InfoOutlinedIcon sx={{ fontSize: 19 }} />
                                  </IconButton>
                                </span>
                              </Tooltip>
                            </MDBox>
                          </MDBox>

                          <TextField
                            fullWidth
                            multiline
                            minRows={1}
                            maxRows={5}
                            placeholder="Escreva uma mensagem..."
                            value={textoMensagem}
                            onChange={(e) => {
                              const novoTexto = e.target.value;
                              setTextoMensagem(novoTexto);
                              atualizarSugestoesMencao(novoTexto);
                              handleTyping(novoTexto);
                            }}
                            onKeyDown={handleKeyDownMensagem}
                            onPaste={handlePasteMensagem}
                            variant="standard"
                            InputProps={{
                              disableUnderline: true,
                            }}
                            sx={{
                              flex: { xs: "1 1 100%", sm: "1 1 auto" },
                              order: { xs: 2, sm: 0 },
                              mt: { xs: 0.5, sm: 0 },
                              "& .MuiInputBase-root": {
                                fontSize: 15,
                                paddingLeft: "6px",
                                paddingRight: "6px",
                              },
                            }}
                          />

                          <MDButton
                            color={mensagemEmEdicao ? "warning" : "info"}
                            onClick={mensagemEmEdicao ? guardarEdicaoMensagem : enviarMensagem}
                            disabled={
                              !chatSelecionado ||
                              enviandoMensagem ||
                              (!textoMensagem.trim() && ficheirosAnexos.length === 0)
                            }
                            sx={{
                              minWidth: { xs: "46px", sm: "52px" },
                              width: { xs: "46px", sm: "52px" },
                              height: { xs: "46px", sm: "52px" },
                              borderRadius: "50%",
                              padding: 0,
                              marginLeft: { xs: "auto", sm: "4px" },
                            }}
                          >
                            {enviandoMensagem ? (
                              "..."
                            ) : mensagemEmEdicao ? (
                              "✓"
                            ) : (
                              <SendIcon sx={{ fontSize: 22 }} />
                            )}
                          </MDButton>
                        </MDBox>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </Card>

                <Card
                  ref={blocoAnexosRef}
                  sx={{
                    border: "1px solid rgba(0,0,0,0.06)",
                    boxShadow: "none",
                    height: { xs: "auto", lg: "100%" },
                    minHeight: 0,
                    backgroundColor: "#f5f6f8",

                    display: { xs: openMobileAnexos ? "block" : "none", lg: "block" },
                    position: { xs: "fixed", lg: "static" },
                    left: { xs: 16, lg: "auto" },
                    right: { xs: 16, lg: "auto" },
                    top: { xs: 110, lg: "auto" },
                    bottom: { xs: 110, lg: "auto" },
                    zIndex: { xs: 1300, lg: "auto" },
                  }}
                >
                  <MDBox
                    sx={{
                      height: "100%",
                      minHeight: 0,
                      display: "flex",
                      flexDirection: "column",
                      overflow: "hidden",
                    }}
                  >
                    <MDBox
                      p={2}
                      pb={0}
                      sx={{
                        flexShrink: 0,
                        backgroundColor: "#f5f6f8",
                        position: "relative",
                        zIndex: 1,
                      }}
                    >
                      <MDBox
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        gap={1}
                      >
                        <MDBox display="flex" alignItems="center" gap={0.75}>
                          <IconButton
                            size="small"
                            onClick={() => setOpenMobileAnexos(false)}
                            sx={{
                              display: { xs: "inline-flex", lg: "none" },
                              width: 28,
                              height: 28,
                              color: "#344767",
                            }}
                          >
                            <Icon>arrow_back</Icon>
                          </IconButton>

                          <MDTypography variant="button" color="text" fontWeight="medium">
                            Anexos
                          </MDTypography>
                        </MDBox>

                        <select
                          value={filtroAnexosMeses}
                          onChange={(e) => setFiltroAnexosMeses(Number(e.target.value))}
                          style={{
                            padding: "4px 6px",
                            borderRadius: 8,
                            border: "1px solid rgba(0,0,0,0.18)",
                            fontSize: 11,
                            background: "white",
                            maxWidth: 90,
                          }}
                        >
                          <option value={1}>1 mês</option>
                          <option value={3}>3 meses</option>
                          <option value={6}>6 meses</option>
                          <option value={9}>9 meses</option>
                          <option value={12}>12 meses</option>
                          <option value={24}>24 meses</option>
                          <option value={0}>Todos</option>
                        </select>
                      </MDBox>

                      <Divider sx={{ mt: 1.5, mb: 0 }} />
                    </MDBox>

                    <MDBox
                      p={2}
                      sx={{
                        flex: 1,
                        minHeight: 0,
                        overflowY: "auto",
                      }}
                    >
                      {anexosChatAtual.length === 0 ? (
                        <MDTypography variant="caption" color="text">
                          Sem anexos no chat atual.
                        </MDTypography>
                      ) : (
                        <MDBox display="flex" flexDirection="column" gap={1}>
                          {anexosChatAtual.map((anexo) => {
                            const href = anexo.url || anexo.caminho_relativo || "#";
                            const isImagem = isImagemAnexo(anexo);
                            const isTextoSimples = isTextoSimplesAnexo(anexo);
                            const chavePreview = `${anexo.idmensagem}-${anexo.id}`;
                            const previewTexto = previewTextoPorAnexo[chavePreview] || "";

                            return (
                              <MDBox
                                key={`${anexo.idmensagem}-${anexo.id}`}
                                component="a"
                                href={href}
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={(e) => {
                                  e.preventDefault();

                                  // FECHAR O DIALOG MOBILE
                                  setOpenMobileAnexos(false);

                                  // IR PARA A MENSAGEM
                                  irParaMensagem(anexo.idmensagem);
                                }}
                                sx={{
                                  display: "block",
                                  textDecoration: "none",
                                  border: "1px solid rgba(0,0,0,0.08)",
                                  borderRadius: 1.5,
                                  px: 1.25,
                                  py: 1,
                                  backgroundColor: "#fff",
                                  cursor:
                                    anexo.url || anexo.caminho_relativo ? "pointer" : "default",
                                }}
                              >
                                {isImagem ? (
                                  <MDBox
                                    sx={{
                                      width: "100%",
                                      height: 140,
                                      borderRadius: 1,
                                      overflow: "hidden",
                                      border: "1px solid rgba(0,0,0,0.08)",
                                      mb: 1,
                                      backgroundColor: "#f5f5f5",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <img
                                      src={href}
                                      alt={anexo.nome_original || anexo.nome_fisico || "Imagem"}
                                      loading="lazy"
                                      decoding="async"
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                        display: "block",
                                      }}
                                    />
                                  </MDBox>
                                ) : isTextoSimples ? (
                                  <MDBox
                                    sx={{
                                      width: "100%",
                                      minHeight: 84,
                                      borderRadius: 1,
                                      border: "1px solid rgba(0,0,0,0.08)",
                                      mb: 1,
                                      backgroundColor: "#f8f9fb",
                                      p: 1,
                                      overflow: "hidden",
                                    }}
                                  >
                                    <MDTypography
                                      variant="caption"
                                      sx={{
                                        display: "block",
                                        color: "#344767",
                                        whiteSpace: "pre-wrap",
                                        wordBreak: "break-word",
                                        lineHeight: 1.45,
                                      }}
                                    >
                                      {previewTexto || "Pré-visualização indisponível."}
                                    </MDTypography>
                                  </MDBox>
                                ) : (
                                  <MDBox
                                    sx={{
                                      width: "100%",
                                      height: 56,
                                      borderRadius: 1,
                                      border: "1px solid rgba(0,0,0,0.08)",
                                      mb: 1,
                                      backgroundColor: "#f8f9fb",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <DescriptionIcon sx={{ color: "#7b809a" }} />
                                  </MDBox>
                                )}

                                <MDTypography
                                  variant="caption"
                                  fontWeight="medium"
                                  sx={{
                                    display: "block",
                                    color: "#1976d2",
                                    wordBreak: "break-word",
                                  }}
                                >
                                  {anexo.nome_original || anexo.nome_fisico || "Anexo"}
                                </MDTypography>

                                <MDTypography
                                  variant="caption"
                                  color="text"
                                  sx={{
                                    display: "block",
                                    mt: 0.25,
                                  }}
                                >
                                  {formatarTamanhoBytes(anexo.tamanho_bytes)}
                                  {anexo.extensao
                                    ? ` • ${String(anexo.extensao).replace(".", "").toUpperCase()}`
                                    : ""}
                                </MDTypography>

                                <MDTypography
                                  variant="caption"
                                  color="text"
                                  sx={{
                                    display: "block",
                                    mt: 0.5,
                                    opacity: 0.7,
                                  }}
                                >
                                  Mensagem #{anexo.idmensagem}
                                  {anexo.utilizador_designacao
                                    ? ` • ${anexo.utilizador_designacao}`
                                    : ""}
                                </MDTypography>

                                {!!anexo.textoMensagem && (
                                  <MDTypography
                                    variant="caption"
                                    color="text"
                                    sx={{
                                      display: "block",
                                      mt: 0.25,
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    {anexo.textoMensagem}
                                  </MDTypography>
                                )}

                                <MDBox
                                  mt={0.75}
                                  display="flex"
                                  alignItems="center"
                                  color="info"
                                  gap={0.5}
                                  sx={{
                                    opacity: 0.7,
                                  }}
                                >
                                  <ChatBubbleOutlineIcon sx={{ fontSize: 14 }} />

                                  <MDTypography color="info" variant="caption">
                                    Ir para mensagem
                                  </MDTypography>
                                </MDBox>

                                <MDBox mt={0.75}>
                                  <MDButton
                                    color="info"
                                    size="small"
                                    variant="text"
                                    sx={{ minWidth: "auto", px: 0, py: 0, fontSize: 11 }}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      window.open(href, "_blank", "noopener,noreferrer");
                                    }}
                                  >
                                    Abrir ficheiro
                                  </MDButton>
                                </MDBox>
                              </MDBox>
                            );
                          })}
                        </MDBox>
                      )}
                    </MDBox>
                  </MDBox>
                </Card>
              </MDBox>
            </MDBox>
          </Card>
        </MDBox>

        <MDBox
          sx={{
            display: { xs: "flex", lg: "none" },
            position: "fixed",
            right: 12,
            bottom: "calc(env(safe-area-inset-bottom) + 92px)",
            zIndex: 1200,
            flexDirection: "column",
            gap: 1,
          }}
        >
          <Tooltip title="Chats">
            <IconButton
              onClick={() => {
                setOpenMobileChats((prev) => !prev);
                setOpenMobileAnexos(false);
              }}
              sx={{
                width: 46,
                height: 46,
                backgroundColor: "#1976d2",
                color: "#fff",
                boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
                "&:hover": { backgroundColor: "#1565c0" },
              }}
            >
              <Icon>forum</Icon>
            </IconButton>
          </Tooltip>

          <Tooltip title="Anexos">
            <IconButton
              onClick={() => {
                setOpenMobileAnexos((prev) => !prev);
                setOpenMobileChats(false);
              }}
              sx={{
                width: 46,
                height: 46,
                backgroundColor: "#7b809a",
                color: "#fff",
                boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
                "&:hover": { backgroundColor: "#6c7088" },
              }}
            >
              <Icon>attach_file</Icon>
            </IconButton>
          </Tooltip>
        </MDBox>

        <Dialog
          open={openReencaminhar}
          onClose={() => {
            if (aReencaminhar) return;
            setOpenReencaminhar(false);
            setMensagemAReencaminhar(null);
            setChatDestinoReencaminhar(null);
          }}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>Reencaminhar mensagem</DialogTitle>

          <DialogContent dividers>
            <MDBox display="grid" gap={2}>
              <MDBox
                sx={{
                  border: "1px solid rgba(0,0,0,0.08)",
                  borderRadius: 1.5,
                  p: 1,
                  backgroundColor: "#f8f9fb",
                }}
              >
                <MDTypography variant="caption" fontWeight="medium" sx={{ display: "block" }}>
                  Mensagem
                </MDTypography>

                <MDTypography
                  variant="caption"
                  color="text"
                  sx={{
                    display: "block",
                    mt: 0.5,
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-word",
                    maxHeight: 120,
                    overflowY: "auto",
                  }}
                >
                  {mensagemAReencaminhar?.texto || "Mensagem com anexo"}
                </MDTypography>

                {Array.isArray(mensagemAReencaminhar?.anexos) &&
                  mensagemAReencaminhar.anexos.length > 0 && (
                    <MDBox display="flex" alignItems="center" gap={0.5} mt={0.75}>
                      <AttachFileIcon sx={{ fontSize: 16, color: "#7b809a" }} />

                      <MDTypography variant="caption" color="text">
                        {mensagemAReencaminhar.anexos.length} anexo(s)
                      </MDTypography>
                    </MDBox>
                  )}
              </MDBox>

              <Autocomplete
                size="small"
                options={chats.filter((c) => String(c.id) !== String(chatSelecionado?.id))}
                value={chatDestinoReencaminhar}
                onChange={(_, value) => setChatDestinoReencaminhar(value || null)}
                getOptionLabel={(option) => option?.designacao || ""}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Chat destino"
                    placeholder="Escolha o chat destino..."
                  />
                )}
              />
            </MDBox>
          </DialogContent>

          <DialogActions>
            <MDButton
              color="secondary"
              disabled={aReencaminhar}
              onClick={() => {
                setOpenReencaminhar(false);
                setMensagemAReencaminhar(null);
                setChatDestinoReencaminhar(null);
              }}
            >
              Cancelar
            </MDButton>

            <MDButton
              color="info"
              disabled={aReencaminhar || !chatDestinoReencaminhar?.id}
              onClick={confirmarReencaminharMensagem}
            >
              {aReencaminhar ? "A reencaminhar..." : "Reencaminhar"}
            </MDButton>
          </DialogActions>
        </Dialog>

        <Dialog
          open={openDetalheReacoes}
          onClose={() => {
            setOpenDetalheReacoes(false);
            setMensagemReacoesDetalhe(null);
            setReacoesDetalhe([]);
          }}
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle>Reações à mensagem</DialogTitle>

          <DialogContent dividers>
            {loadingReacoesDetalhe ? (
              <MDBox py={2} display="flex" justifyContent="center">
                <CircularProgress size={24} />
              </MDBox>
            ) : reacoesDetalhe.length === 0 ? (
              <MDTypography variant="body2" color="text">
                Esta mensagem ainda não tem reações.
              </MDTypography>
            ) : (
              <MDBox display="flex" flexDirection="column" gap={1.5}>
                {Object.entries(
                  reacoesDetalhe.reduce((acc, item) => {
                    const key = item.reacao || "?";
                    if (!acc[key]) acc[key] = [];
                    acc[key].push(item);
                    return acc;
                  }, {})
                ).map(([reacao, utilizadores]) => (
                  <MDBox
                    key={reacao}
                    sx={{
                      border: "1px solid rgba(0,0,0,0.08)",
                      borderRadius: 1.5,
                      overflow: "hidden",
                    }}
                  >
                    <MDBox
                      px={1.5}
                      py={1}
                      display="flex"
                      alignItems="center"
                      justifyContent="space-between"
                      sx={{ backgroundColor: "#f8f9fb" }}
                    >
                      <MDTypography variant="button" fontWeight="medium">
                        {reacao}
                      </MDTypography>

                      <MDTypography variant="caption" color="text">
                        {utilizadores.length}
                      </MDTypography>
                    </MDBox>

                    <MDBox p={1.5} display="flex" flexDirection="column" gap={1}>
                      {utilizadores.map((u) => (
                        <MDBox
                          key={`${reacao}-${u.idutilizador}`}
                          display="flex"
                          alignItems="center"
                          gap={1}
                        >
                          {renderAvatarUtilizador({
                            id: u.idutilizador,
                            designacao: u.utilizador_designacao,
                          })}

                          <MDBox sx={{ minWidth: 0 }}>
                            <MDTypography variant="button" fontWeight="medium">
                              {u.utilizador_designacao}
                            </MDTypography>

                            <MDTypography variant="caption" color="text" sx={{ display: "block" }}>
                              @{u.utilizador_username}
                            </MDTypography>
                          </MDBox>
                        </MDBox>
                      ))}
                    </MDBox>
                  </MDBox>
                ))}
              </MDBox>
            )}
          </DialogContent>

          <DialogActions>
            <MDButton
              color="secondary"
              onClick={() => {
                setOpenDetalheReacoes(false);
                setMensagemReacoesDetalhe(null);
                setReacoesDetalhe([]);
              }}
            >
              Fechar
            </MDButton>
          </DialogActions>
        </Dialog>

        <Dialog
          open={openMembrosChat}
          onClose={() => setOpenMembrosChat(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>Membros do chat</DialogTitle>

          <DialogContent dividers>
            <MDTypography variant="button" fontWeight="medium" sx={{ display: "block", mb: 1 }}>
              Membros atuais
            </MDTypography>

            {membrosChat.length === 0 ? (
              <MDTypography variant="caption" color="text">
                Sem membros carregados.
              </MDTypography>
            ) : (
              <MDBox display="flex" flexDirection="column" gap={1}>
                {membrosChat.map((membro) => (
                  <MDBox
                    key={membro.idutilizador || membro.id}
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    gap={1}
                    sx={{
                      border: "1px solid rgba(0,0,0,0.08)",
                      borderRadius: 1.5,
                      px: 1.25,
                      py: 1,
                      backgroundColor: membro.observador ? "#f5f5f5" : "#fff",
                    }}
                  >
                    <MDBox display="flex" alignItems="center" gap={1} sx={{ minWidth: 0 }}>
                      {renderAvatarUtilizador(membro)}

                      <MDBox sx={{ minWidth: 0 }}>
                        <MDTypography variant="button" fontWeight="medium">
                          {membro.designacao}
                        </MDTypography>

                        <MDTypography
                          variant="caption"
                          color="text"
                          sx={{ display: "block", opacity: 0.75 }}
                        >
                          @{membro.username}
                          {membro.administrador ? " • Administrador" : ""}
                          {membro.observador ? " • Observador" : ""}
                        </MDTypography>
                      </MDBox>
                    </MDBox>

                    {!membro.observador &&
                      String(membro.idutilizador || membro.id) !== String(userData.id) && (
                        <MDButton
                          color="error"
                          size="small"
                          onClick={() => {
                            setMembroParaRemover(membro);
                            setOpenConfirmarRemoverMembro(true);
                          }}
                          disabled={aAtualizarMembros}
                        >
                          Remover
                        </MDButton>
                      )}
                  </MDBox>
                ))}
              </MDBox>
            )}

            <MDBox mt={2}>
              <MDTypography variant="button" fontWeight="medium" sx={{ display: "block", mb: 1 }}>
                Utilizadores disponíveis
              </MDTypography>

              <MDBox display="flex" flexDirection="column" gap={1}>
                {utilizadores
                  .filter(
                    (u) => !membrosChat.some((m) => String(m.idutilizador || m.id) === String(u.id))
                  )
                  .map((u) => (
                    <MDBox
                      key={u.id}
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      gap={1}
                      sx={{
                        border: "1px solid rgba(0,0,0,0.08)",
                        borderRadius: 1.5,
                        px: 1.25,
                        py: 1,
                        backgroundColor: "#fff",
                      }}
                    >
                      <MDBox display="flex" alignItems="center" gap={1} sx={{ minWidth: 0 }}>
                        {renderAvatarUtilizador(u)}

                        <MDBox sx={{ minWidth: 0 }}>
                          <MDTypography variant="button" fontWeight="medium">
                            {u.designacao}
                          </MDTypography>

                          <MDTypography
                            variant="caption"
                            color="text"
                            sx={{ display: "block", opacity: 0.75 }}
                          >
                            @{u.username}
                            {u.funcoes ? ` • ${u.funcoes}` : ""}
                          </MDTypography>
                        </MDBox>
                      </MDBox>
                      <MDButton
                        color="success"
                        size="small"
                        onClick={() => adicionarMembroChat(u)}
                        disabled={aAtualizarMembros}
                      >
                        Adicionar
                      </MDButton>
                    </MDBox>
                  ))}

                {utilizadores.filter(
                  (u) => !membrosChat.some((m) => String(m.idutilizador || m.id) === String(u.id))
                ).length === 0 && (
                  <MDTypography variant="caption" color="text">
                    Não existem utilizadores disponíveis para adicionar.
                  </MDTypography>
                )}
              </MDBox>
            </MDBox>
          </DialogContent>

          <DialogActions>
            <MDButton color="secondary" onClick={() => setOpenMembrosChat(false)}>
              Fechar
            </MDButton>
          </DialogActions>
        </Dialog>

        <Dialog
          open={openConfirmarRemoverMembro}
          onClose={() => setOpenConfirmarRemoverMembro(false)}
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle>Remover membro</DialogTitle>

          <DialogContent dividers>
            <MDTypography variant="body2">
              Tem a certeza que pretende remover{" "}
              <strong>{membroParaRemover?.designacao || "este membro"}</strong> deste chat?
            </MDTypography>
          </DialogContent>

          <DialogActions>
            <MDButton
              color="secondary"
              onClick={() => {
                setOpenConfirmarRemoverMembro(false);
                setMembroParaRemover(null);
              }}
            >
              Cancelar
            </MDButton>

            <MDButton
              color="error"
              disabled={aAtualizarMembros}
              onClick={async () => {
                const membro = membroParaRemover;
                setOpenConfirmarRemoverMembro(false);
                setMembroParaRemover(null);
                await removerMembroChat(membro);
              }}
            >
              Remover
            </MDButton>
          </DialogActions>
        </Dialog>

        <Dialog open={openNovoChat} onClose={() => setOpenNovoChat(false)} maxWidth="sm" fullWidth>
          <DialogTitle>Novo Chat</DialogTitle>

          <DialogContent>
            <MDBox display="grid" gap={2} mt={1}>
              <div>
                <div style={{ fontSize: 12, color: "#7b809a", marginBottom: 4 }}>
                  Nome do chat (opcional)
                </div>
                <TextField
                  fullWidth
                  size="small"
                  value={novoChat.designacao}
                  onChange={(e) => setNovoChat((prev) => ({ ...prev, designacao: e.target.value }))}
                  placeholder="Ex.: Comercial Norte"
                />
              </div>

              <div>
                <div style={{ fontSize: 12, color: "#7b809a", marginBottom: 4 }}>
                  Descrição (opcional)
                </div>
                <TextField
                  fullWidth
                  size="small"
                  value={novoChat.descricao}
                  onChange={(e) => setNovoChat((prev) => ({ ...prev, descricao: e.target.value }))}
                  placeholder="Descrição do chat"
                />
              </div>

              <div>
                <div style={{ fontSize: 12, color: "#7b809a", marginBottom: 4 }}>Utilizadores</div>
                <Autocomplete
                  multiple
                  size="small"
                  options={utilizadores}
                  loading={loadingUtilizadores}
                  getOptionLabel={(option) =>
                    `${option.designacao || ""} (${option.username || ""})`
                  }
                  value={novoChat.membros}
                  onChange={(_, value) =>
                    setNovoChat((prev) => ({ ...prev, membros: value || [] }))
                  }
                  renderInput={(params) => (
                    <TextField {...params} placeholder="Selecione os utilizadores..." />
                  )}
                />
              </div>
            </MDBox>
          </DialogContent>

          <DialogActions>
            <MDButton color="secondary" onClick={() => setOpenNovoChat(false)}>
              Cancelar
            </MDButton>

            <MDButton
              color="info"
              onClick={criarNovoChat}
              disabled={aCriarChat || !novoChat.membros.length}
            >
              {aCriarChat ? "A criar..." : "Criar"}
            </MDButton>
          </DialogActions>
        </Dialog>

        <Dialog open={openInfoVoz} onClose={() => setOpenInfoVoz(false)} maxWidth="sm" fullWidth>
          <DialogTitle>Comandos de voz</DialogTitle>

          <DialogContent>
            <MDBox display="grid" gap={1} mt={1}>
              <MDTypography variant="body2">
                Pode ditar texto em português com <MicIcon />, falando devagar e de forma clara.
                <br />
                Pode usar estes comandos de voz:
              </MDTypography>

              <MDTypography variant="caption">
                • “ponto final” → fecha a frase e muda de linha
              </MDTypography>
              <MDTypography variant="caption">• “ponto de interrogação” → adiciona ?</MDTypography>
              <MDTypography variant="caption">• “ponto de exclamação” → adiciona !</MDTypography>
              <MDTypography variant="caption">• “dois pontos” → adiciona :</MDTypography>
              <MDTypography variant="caption">• “ponto e vírgula” → adiciona ;</MDTypography>
              <MDTypography variant="caption">
                • “linha” ou “nova linha” → cria novo parágrafo
              </MDTypography>
            </MDBox>
          </DialogContent>

          <DialogActions>
            <MDButton color="secondary" onClick={() => setOpenInfoVoz(false)}>
              Fechar
            </MDButton>
          </DialogActions>
        </Dialog>

        <Dialog
          open={resultadosPesquisaChat.length > 0}
          onClose={() => setResultadosPesquisaChat([])}
          maxWidth="sm"
          fullWidth
          PaperComponent={PaperComponent}
        >
          <DialogTitle id="dialog-resultados-pesquisa-title" sx={{ cursor: "move" }}>
            Resultados da pesquisa ({resultadosPesquisaChat.length})
          </DialogTitle>

          <DialogContent dividers>
            <MDBox display="flex" flexDirection="column" gap={0.75}>
              {resultadosPesquisaChat.map((r) => (
                <MDBox
                  key={r.id}
                  onClick={() => {
                    irParaMensagem(r.id);
                  }}
                  sx={{
                    p: 1,
                    borderRadius: 1,
                    cursor: "pointer",
                    backgroundColor: "rgba(25,118,210,0.04)",
                    "&:hover": {
                      backgroundColor: "rgba(25,118,210,0.10)",
                    },
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <MDBox sx={{ minWidth: 0, flex: 1 }}>
                    <MDTypography variant="caption" fontWeight="medium" sx={{ display: "block" }}>
                      {r.utilizador_designacao}
                    </MDTypography>

                    <MDTypography
                      variant="caption"
                      color="text"
                      sx={{
                        display: "block",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {r.texto || "Mensagem com anexo"}
                    </MDTypography>
                  </MDBox>

                  {Number(r.total_anexos || 0) > 0 && (
                    <AttachFileIcon sx={{ ml: 1, opacity: 0.7, fontSize: 20 }} />
                  )}
                </MDBox>
              ))}
            </MDBox>
          </DialogContent>

          <DialogActions>
            <MDButton color="secondary" onClick={() => setResultadosPesquisaChat([])}>
              Fechar
            </MDButton>
          </DialogActions>
        </Dialog>

        <Dialog
          open={resultadosPesquisaGlobal.length > 0}
          onClose={() => setResultadosPesquisaGlobal([])}
          maxWidth="md"
          fullWidth
          PaperComponent={PaperComponent}
        >
          <DialogTitle id="dialog-resultados-pesquisa-title" sx={{ cursor: "move" }}>
            Resultados globais ({resultadosPesquisaGlobal.length})
          </DialogTitle>

          <DialogContent dividers>
            <MDBox display="flex" flexDirection="column" gap={0.75}>
              {resultadosPesquisaGlobal.map((r) => (
                <MDBox
                  key={`${r.idchat}-${r.id}`}
                  onClick={() => {
                    const chatAlvo = chats.find((c) => String(c.id) === String(r.idchat));

                    if (!chatAlvo) return;

                    if (String(chatSelecionado?.id) === String(r.idchat)) {
                      irParaMensagem(r.id);
                      return;
                    }

                    setMensagemGlobalPendente(r.id);
                    setChatSelecionado(chatAlvo);
                  }}
                  sx={{
                    p: 1,
                    borderRadius: 1,
                    cursor: "pointer",
                    backgroundColor: "rgba(25,118,210,0.04)",
                    "&:hover": {
                      backgroundColor: "rgba(25,118,210,0.10)",
                    },
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <MDBox sx={{ minWidth: 0, flex: 1 }}>
                    <MDTypography variant="caption" fontWeight="medium" sx={{ display: "block" }}>
                      {r.chat_designacao} • {r.utilizador_designacao}
                    </MDTypography>

                    <MDTypography
                      variant="caption"
                      color="text"
                      sx={{
                        display: "block",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {r.texto || "Mensagem com anexo"}
                    </MDTypography>
                  </MDBox>

                  {Number(r.total_anexos || 0) > 0 && (
                    <AttachFileIcon sx={{ ml: 1, opacity: 0.7, fontSize: 20 }} />
                  )}
                </MDBox>
              ))}
            </MDBox>
          </DialogContent>

          <DialogActions>
            <MDButton color="secondary" onClick={() => setResultadosPesquisaGlobal([])}>
              Fechar
            </MDButton>
          </DialogActions>
        </Dialog>

        <Dialog
          open={openEnviarEmail}
          onClose={() => {
            if (aEnviarEmail) return;
            setOpenEnviarEmail(false);
            setMensagemAEnviarEmail(null);
            setUtilizadoresEmail([]);
            setEmailsLivres("");
          }}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>Reencaminhar por email</DialogTitle>

          <DialogContent dividers>
            <MDBox display="grid" gap={2}>
              {/* Preview da mensagem */}
              <MDBox
                sx={{
                  border: "1px solid rgba(0,0,0,0.08)",
                  borderRadius: 1.5,
                  p: 1,
                  backgroundColor: "#f8f9fb",
                }}
              >
                <MDTypography variant="caption" fontWeight="medium">
                  Mensagem
                </MDTypography>

                <MDTypography
                  variant="caption"
                  color="text"
                  sx={{
                    display: "block",
                    mt: 0.5,
                    whiteSpace: "pre-wrap",
                  }}
                >
                  {mensagemAEnviarEmail?.texto || "Mensagem com anexo"}
                </MDTypography>
              </MDBox>

              {/* Utilizadores internos */}
              <Autocomplete
                multiple
                size="small"
                options={utilizadores}
                value={utilizadoresEmail}
                onChange={(_, value) => setUtilizadoresEmail(value || [])}
                getOptionLabel={(u) => `${u.designacao} (${u.email || ""})`}
                renderInput={(params) => <TextField {...params} label="Utilizadores internos" />}
              />

              {/* Emails livres */}
              <TextField
                size="small"
                fullWidth
                label="Emails externos"
                placeholder="email1@...; email2@..."
                value={emailsLivres}
                onChange={(e) => setEmailsLivres(e.target.value)}
              />
            </MDBox>
          </DialogContent>

          <DialogActions>
            <MDButton
              color="secondary"
              disabled={aEnviarEmail}
              onClick={() => setOpenEnviarEmail(false)}
            >
              Cancelar
            </MDButton>

            <MDButton
              color="info"
              disabled={aEnviarEmail}
              onClick={async () => {
                if (!mensagemAEnviarEmail?.id) return;

                setAEnviarEmail(true);

                const emailsExtra = emailsLivres
                  .split(/[;,\n]+/)
                  .map((e) => e.trim())
                  .filter((e) => e);

                const [data, err, meta] = await handleApi(
                  api.post("Chats/ReencaminharMensagemEmail", {
                    idmensagem: mensagemAEnviarEmail.id,
                    idutilizador: userData.id,
                    emails: emailsExtra,
                    idutilizadores: utilizadoresEmail.map((u) => u.id),
                  })
                );

                if (err) {
                  showAlert(err, "error");
                  setAEnviarEmail(false);
                  return;
                }

                if (meta?.message) {
                  showAlert(meta.message, meta.severity || "success");
                }

                setOpenEnviarEmail(false);
                setMensagemAEnviarEmail(null);
                setUtilizadoresEmail([]);
                setEmailsLivres("");

                setAEnviarEmail(false);
              }}
            >
              {aEnviarEmail ? "A enviar..." : "Enviar"}
            </MDButton>
          </DialogActions>
        </Dialog>
      </DashboardLayout>
    </>
  );
}
